<template>
    <div class="individual-teaching2">
        <Head v-show="$store.state.headShow" :show-subject="true"></Head>
        <div class="container">
            <div class="tabs">
                <span class="tab" :class="{'selected': tabIndex === 0}" @click="switchTab(0)">目标分析</span>
                <span class="tab" :class="{'selected': tabIndex === 1}" @click="switchTab(1)">目标评估</span>
            </div>
            <div class="left-part" ref="leftPart" :style="[isBatchEdit ? {'height': 'calc(100% - 150px)'} : '']">
                <div class="search-box">
                    <el-input v-model="searchText" placeholder="请输入内容关键词" />
                    <span><i class="el-icon-search"></i></span>
                </div>
<!--                <div v-if="!searchText" class="publisher-grade-filter">-->
<!--                    <el-popover popper-class="popover-publisher-grade" width="360">-->
<!--                        <span slot="reference">-->
<!--                            更多筛选条件-->
<!--                            <font-awesome-icon icon="filter" />-->
<!--                        </span>-->
<!--                        <div>-->
<!--                            <p>教材版本</p>-->
<!--                            <div>-->
<!--                                <span v-for="(publisher, index) of publisherList" :key="publisher['id']" :class="{'active': publisherIndex === index}" @click="changePublisher(index)">{{publisher['name']}}</span>-->
<!--                            </div>-->
<!--                            <p>年级</p>-->
<!--                            <div>-->
<!--                                <span v-for="(grade, index) of gradeList" :key="grade['id']" :class="{'active': gradeIndex === index}" @click="changeGrade(index)">{{grade['name']}}</span>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                    </el-popover>-->
<!--                </div>-->
                <div class="knowledge-tree">
                    <el-tree v-if="!searchText"
                             icon-class="el-icon-circle-plus"
                             :props="treeProps"
                             ref="tree"
                             :load="loadNode"
                             node-key="id"
                             :current-node-key="activeNode.id"
                             :highlight-current="true"
                             :expand-on-click-node="false"
                             lazy
                             @node-click="handleNodeClick"></el-tree>
                    <div v-else-if="searchedKnowledgeList && searchedKnowledgeList.length > 0" class="search-items">
                        <div v-for="(knowledge, index) of searchedKnowledgeList"
                             :key="knowledge['id'] + '_' + index"
                             :class="{'active': index === selectedSearchItemIndex }"
                             @click="onSearchedItemClick(knowledge, index)">
                            {{knowledge['name'].includes('-') ? knowledge['name'].split('-').slice(-1)[0] : knowledge['name']}}
                        </div>
                    </div>
                </div>
            </div>
            <div class="right-part" :style="[isBatchEdit ? {'height': 'calc(100% - 116px)'} : '']">
                <div class="selection-bar">
                    <el-select v-model="selectedTermName" placeholder="请选择学期" class="term-selection" @change="queryDetail">
                        <el-option v-for="term of termList" :key="term['schoolYear'] + '_' + term['termId']" :value="term['name']">{{term['name']}}</el-option>
                    </el-select>
                    <el-select v-model="selectedGroup" :collapse-tags="true" multiple placeholder="请选择小组或学生" class="group-selection" @change="queryDetail">
                        <el-option v-for="group of groupList.concat(studentList)" :key="group['id']" :value="group['name']">{{group['name']}}</el-option>
                    </el-select>
                    <div class="evaluation-filter">
                        <div :class="{'selected': evaluationTypeList.includes(1)}" @click="selectEvaluationType(1)">课前评估</div>
                        <div v-if="tabIndex === 1" :class="{'selected': evaluationTypeList.includes(1.5)}" @click="selectEvaluationType(1.5)">达成目标</div>
                        <div v-if="tabIndex === 1" :class="{'selected': evaluationTypeList.includes(2)}" @click="selectEvaluationType(2)">作业反馈</div>
                        <div :class="{'selected': evaluationTypeList.includes(3)}" @click="selectEvaluationType(3)">课后评估</div>
                        <div :class="{'selected': evaluationTypeList.includes(4)}" @click="selectEvaluationType(4)">期末评估</div>
                    </div>
                </div>
                <div class="container" ref="container">
                    <div class="header">
                        <div class="breadcrumb">
                            <template v-for="(item, index) of nodeNameChain">
                                <span :key="item.id + '_' + index" class="node-name" @click="jump2Node(item.id, index)">{{item.name}}</span>
                                <i v-if="index !== nodeNameChain.length - 1" :key="item.id + '__' + index" class="el-icon-arrow-right"></i>
                            </template>
                        </div>
                        <div v-if="tabIndex === 0" class="selector">
                            <el-dropdown trigger="click" @command="filterStudent">
                                <span class="el-dropdown-link">{{allFilterStudentList[allFilterStudentListIndex] && allFilterStudentList[allFilterStudentListIndex].name}}<i class="el-icon-arrow-down el-icon--right"></i></span>
                                <el-dropdown-menu slot="dropdown" class="student-selector">
                                    <el-dropdown-item v-for="(item, index) of allFilterStudentList" :key="item.id" :command="index">{{item.name}}</el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                        </div>
                        <div v-if="tabIndex === 1" class="operation">
                            <div class="filter-label"
                                 :class="{'checked': isMyTeachingGoalChecked}"
                                 @click="getMyTeachingGoals">
                                <img v-if="!isMyTeachingGoalChecked" src="../assets/image/individualTeaching/white-solid-circle-check.png" alt="" />
                                <img v-else src="../assets/image/individualTeaching/blue-white-solid-circle-check.png" alt="" />
                                <span>我的教学目标</span>
                            </div>
                            <div class="filter-label"
                                 :class="{'checked': isNoEvaluatedGoalChecked}"
                                 @click="getUnevaluatedGoals">
                                <img v-if="!isNoEvaluatedGoalChecked" src="../assets/image/individualTeaching/white-solid-circle-check.png" alt="" />
                                <img v-else src="../assets/image/individualTeaching/blue-white-solid-circle-check.png" alt="" />
                                <span>未评估目标</span>
                            </div>
                            <div v-if="evaluationTableData && evaluationTableData.length > 0" class="download" @click="downloadTarget">
                                <img src="../assets/image/individualTeaching/download.png" alt="" />
                                <span>下载教学目标</span>
                            </div>
                            <div v-if="evaluationTableData && evaluationTableData.length > 0" class="edit" @click="isBatchEdit = true">
                                <img src="../assets/image/individualTeaching/edit.png" alt="" />
                                <span>批量修改</span>
                            </div>
                        </div>
                    </div>
                    <div v-if="tabIndex === 0" class="chart-container">
                        <div class="top">
                            <div class="switcher">
                                <span :class="{'selected': chartTypeIndex === 0}" @click="changeChartType(0)">柱状图</span>
                                <span :class="{'selected': chartTypeIndex === 1}" @click="changeChartType(1)">折线图</span>
                            </div>
                            <div class="legend">
                                <template v-if="evaluationTypeList.includes(1)">
                                    <i class="before"></i>
                                    <span>课前评估</span>
                                </template>
                                <template v-if="evaluationTypeList.includes(3)">
                                    <i class="after"></i>
                                    <span>课后评估</span>
                                </template>
                                <template v-if="evaluationTypeList.includes(4)">
                                    <i class="end"></i>
                                    <span>期末评估</span>
                                </template>
                            </div>
                            <div class="no-evaluation">
                                <el-checkbox v-model="isNoEvaluationChecked">不显示未评估项目</el-checkbox>
                                <el-checkbox v-model="isTeachingTarget">教学目标</el-checkbox>
                                <el-checkbox v-if="this.filterStudentIds.length === 1" v-model="singleAverage">小组平均</el-checkbox>
                            </div>
                        </div>
                        <div class="chart-wrapper">
                            <div class="chart" ref="chart"></div>
                        </div>
                    </div>
                    <div class="table-container">
                        <template v-if="tabIndex === 0">
                            <div class="description">
<!--                                <div>-->
<!--                                    <i class="el-icon-warning"></i>-->
<!--                                    <span>说明：平均分</span>-->
<!--                                    <span v-if="!isLessNumSetterShown" class="scope" @click="isLessNumSetterShown = !isLessNumSetterShown">-->
<!--                                        <template v-if="lessNum !== '' && lessNum >= 0">-->
<!--                                            {{lessIndex === 0 ? '≤' : '&lt;'}}{{lessNum}}-->
<!--                                        </template>-->
<!--                                    </span>-->
<!--                                    <div v-if="isLessNumSetterShown" class="scope-setter">-->
<!--                                        <el-dropdown trigger="click" @command="lessIndex = $event">-->
<!--                                            <span class="el-dropdown-link">{{lessList[lessIndex]}}<i class="el-icon-arrow-down el-icon&#45;&#45;right"></i></span>-->
<!--                                            <el-dropdown-menu slot="dropdown">-->
<!--                                                <el-dropdown-item v-for="(item, index) of lessList" :key="item" :command="index">{{item}}</el-dropdown-item>-->
<!--                                            </el-dropdown-menu>-->
<!--                                        </el-dropdown>-->
<!--                                        <el-input v-model="lessNum" class="score"></el-input>-->
<!--                                        <span class="btn" @click="setLessNum">确定</span>-->
<!--                                    </div>-->
<!--                                    <span>分显示为</span>-->
<!--                                    <span class="blue scope-color"></span>，-->
<!--                                    <span v-if="!isGreaterNumSetterShown" class="scope" @click="isGreaterNumSetterShown = !isGreaterNumSetterShown">-->
<!--                                        <template v-if="greaterNum !== '' && greaterNum >= 0">-->
<!--                                            {{greaterIndex === 0 ? '≥' : '&gt;'}}{{greaterNum}}-->
<!--                                        </template>-->
<!--                                    </span>-->
<!--                                    <div v-if="isGreaterNumSetterShown" class="scope-setter">-->
<!--                                        <el-dropdown trigger="click" @command="greaterIndex = $event">-->
<!--                                            <span class="el-dropdown-link">{{greaterList[greaterIndex]}}<i class="el-icon-arrow-down el-icon&#45;&#45;right"></i></span>-->
<!--                                            <el-dropdown-menu slot="dropdown">-->
<!--                                                <el-dropdown-item v-for="(item, index) of greaterList" :key="item" :command="index">{{item}}</el-dropdown-item>-->
<!--                                            </el-dropdown-menu>-->
<!--                                        </el-dropdown>-->
<!--                                        <el-input v-model="greaterNum" class="score"></el-input>-->
<!--                                        <span class="btn" @click="setGreaterNum">确定</span>-->
<!--                                    </div>-->
<!--                                    <span>分显示为</span>-->
<!--                                    <span class="pink scope-color"></span>，-->
<!--                                    <span>其他显示为</span>-->
<!--                                    <span class="white scope-color"></span>-->
<!--                                </div>-->
                                <div class="color-control">
                                    <div class="left-color">
                                        <div class="normal-else one"></div>
                                        <div class="normal-else two"></div>
                                        <div class="normal-else three"></div>
                                        <div class="normal-else four"></div>
                                        <div class="normal-else five"></div>
                                        <div class="normal-else six"></div>
                                        <div class="normal-else seven"></div>
                                        <div class="normal-else eight"></div>
                                    </div>
                                    <div class="color-choose">
                                        <el-switch
                                                v-model="colorSelect">
                                        </el-switch>
                                    </div>
                                    <div class="left-color">
                                        <div class="normal one"></div>
                                        <div class="normal two"></div>
                                        <div class="normal three"></div>
                                        <div class="normal four"></div>
                                        <div class="normal five"></div>
                                        <div class="normal six"></div>
                                        <div class="normal seven"></div>
                                        <div class="normal eight"></div>
                                    </div>
                                </div>
                                <div v-if="analysisTableData && analysisTableData.length > 0" class="download" @click="downloadAnalysisTable">
                                    <img src="../assets/image/individualTeaching/download.png" alt="" />
                                    <span>下载</span>
                                </div>
                            </div>
                            <el-table :data="analysisTableData"
                                      :cell-class-name="setCellClassName"
                                      :cell-style="{'textAlign': 'center', 'width': '50px'}"
                                      header-cell-class-name="header-cell"
                                      :height="analysisTableHeight"
                                      ref="analysisTable"
                                      @mouseover.native="changeDefaultColumnSortOrder"
                                      @sort-change="sortChange">
                                <el-table-column v-if="analysisTableData && analysisTableData.length > 0" prop="name" label="姓名" width="120px">
                                    <template v-slot="{row, column, $index}">
                                        <span style="cursor: pointer;" @click="showStudentGrowth(row['studentId'], row['name'])">{{row['name']}}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column v-for="col of analysisColumnList" min-width="150px" :key="col.id">
                                    <template slot="header">
                                        <span>{{col.name}}</span>
                                        <div class="icon-plus">
                                            <i class="el-icon-plus" @click="showTargetListDialog(col.id)"></i>
                                        </div>
                                    </template>
                                    <template v-for="type of evaluationTypeList">
                                        <el-table-column v-if="type === 1"
                                                         :key="type"
                                                         :prop="`before_${col.id}`"
                                                         :label-class-name="`before_${col.id}`"
                                                         :class-name="`before_${col.id}` === currentSort.columnId ? currentSort.order : ''"
                                                         :sort-orders="`before_${col.id}` === currentSort.columnId ? columnSortOrders : defaultColumnSortOrder"
                                                         :width="(evaluationTypeList.includes(2) && evaluationTypeList.length > 2
                                                                  || !evaluationTypeList.includes(2) && evaluationTypeList.length) ? '80px' : '160px'"
                                                         sortable="custom"
                                                         label="课前">
                                            <template v-slot="{row, column, $index}">
                                                <span>{{analysisTableData[$index]['before_' + col.id]}}</span>
                                                <img v-if="analysisTableData[$index]['isTarget_' + col.id] && evaluationTypeList[evaluationTypeList.length - 1] === 2" style="position: absolute; right: 0;top:0;width: 8px" src="../assets/image/individualTeaching/three.png" alt="">
                                            </template>
                                        </el-table-column>
                                        <el-table-column v-if="type === 3"
                                                         :key="type"
                                                         :prop="`after_${col.id}`"
                                                         :label-class-name="`after_${col.id}`"
                                                         :class-name="`after_${col.id}` === currentSort.columnId ? currentSort.order : ''"
                                                         :sort-orders="`after_${col.id}` === currentSort.columnId ? columnSortOrders : defaultColumnSortOrder"
                                                         :width="(evaluationTypeList.includes(2) && evaluationTypeList.length > 2
                                                                  || !evaluationTypeList.includes(2) && evaluationTypeList.length) ? '80px' : '160px'"
                                                         sortable="custom"
                                                         label="课后">
                                            <template v-slot="{row, column, $index}">
                                                <span>{{analysisTableData[$index]['after_' + col.id]}}</span>
                                                <img v-if="analysisTableData[$index]['isTarget_' + col.id] && evaluationTypeList[evaluationTypeList.length - 1] === 3" style="position: absolute; right: 0;top:0;width: 8px" src="../assets/image/individualTeaching/three.png" alt="">
                                            </template>
                                        </el-table-column>

                                        <el-table-column v-if="type === 4"
                                                         :key="type"
                                                         :label-class-name="`end_${col.id}`"
                                                         :prop="`end_${col.id}`"
                                                         :class-name="`end_${col.id}` === currentSort.columnId ? currentSort.order : ''"
                                                         :sort-orders="`end_${col.id}` === currentSort.columnId ? columnSortOrders : defaultColumnSortOrder"
                                                         :width="(evaluationTypeList.includes(2) && evaluationTypeList.length > 2
                                                                  || !evaluationTypeList.includes(2) && evaluationTypeList.length) ? '80px' : '160px'"
                                                         sortable="custom"
                                                         style="position: relative"
                                                         label="期末">
                                            <template v-slot="{row, column, $index}">
                                                <span>{{analysisTableData[$index]['end_' + col.id]}}</span>
                                                <img v-if="analysisTableData[$index]['isTarget_' + col.id] && evaluationTypeList[evaluationTypeList.length - 1] === 4" style="position: absolute; right: 0;top:0;width: 8px" src="../assets/image/individualTeaching/three.png" alt="">
                                            </template>
                                        </el-table-column>
                                    </template>
                                </el-table-column>
                            </el-table>
                            <div class="pager">
                                <el-pagination :page-size="analysisPageSize"
                                               :total="analysisRowTotal"
                                               :current-page.sync="analysisCurrentPage"
                                               layout="prev, pager, next, jumper"></el-pagination>
                            </div>
                        </template>
                        <div v-if="tabIndex === 1" class="evaluation-table">
                            <el-table :data="evaluationTableData"
                                      :height="evaluationTableHeight"
                                      :span-method="evaluationTableSpanMethod"
                                      ref="evaluationTable"
                                      :cell-class-name="evaluationCellMethod"
                                      header-cell-class-name="evaluation-header-cell">
                                <el-table-column v-if="evaluationTableData && evaluationTableData.length > 0" label="目标" prop="name" width="250px" class-name="evaluation-fixed-column" fixed>
                                    <template v-slot="{row, column, $index}">
                                        <div v-if="row['isCustom']">
                                            <span class="custom-label">自定义</span>
                                            <input :ref="`targetName${$index}`" type="text" class="custom-target-name" @keyup.enter="setCustomTarget(row, $index, $event.target.value)" />
                                            <span class="save-btn" @click="saveCustomTarget(row, $index, `targetName${$index}`)">保存</span>
                                        </div>
                                        <div v-else-if="row['isCustomOrigin']">
                                            <span class="custom-label">自定义</span>
                                            <span style="cursor: pointer" @click="renameCustomTargetName(row, $index)">{{row['name']}}</span>
                                        </div>
                                        <span @click="getPointFileList2(row)" v-else :class="{'target-path': Object.keys(row).length === 1}">{{row['name']}}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column v-if="evaluationTableData && evaluationTableData.length > 0" label="教学目标" prop="isTarget" width="80px" class-name="evaluation-fixed-column" fixed>
                                    <template v-slot="{row, column, $index}">
                                        <span v-if="Object.keys(row).length === 1" class="add-custom-target" @click="addCustomTarget($index)">
                                            <img src="../assets/image/individualTeaching/blue-plus.png" alt="" />
                                            <span>自定义目标</span>
                                        </span>
                                        <template v-else>
                                            <img v-if="!row['isCustom'] && !row['isCustomOrigin'] && row['isTarget'] && row['targetStatus'] === 2" src="../assets/image/individualTeaching/blue-solid-circle-check.png" alt=""
                                                 class="target-update" @click="unmarkTarget(row)" />
                                            <img v-else-if="!row['isCustom'] && !row['isCustomOrigin'] && !row['isTarget'] && row['targetStatus'] === 0" src="../assets/image/individualTeaching/empty-circle-check.png" alt=""
                                                 class="target-update" @click="markTarget(row)" />
                                            <img v-else-if="!row['isCustom'] && !row['isCustomOrigin'] && row['isTarget'] && row['targetStatus'] === 1" src="../assets/image/individualTeaching/half-select.png" alt=""
                                                 class="target-update" @click="markTarget(row)" />
                                            <img v-if="row['isCustom'] || row['isCustomOrigin']" src="../assets/image/individualTeaching/circle-close.png" alt=""
                                             class="target-update" @click="removeCustomTarget(row, $index)" />
                                        </template>
                                    </template>
                                </el-table-column>
                                <el-table-column v-for="col of evaluationColumnListComputed" :key="col.id">
                                    <template slot="header">
                                      <!--<span style="cursor: pointer;" @click="showStudentGrowth(col.id, col.name)">{{col.name}}</span>-->
                                      <span>{{col.name}}</span>
                                    </template>
                                    <template v-for="type of evaluationTypeList">
                                        <el-table-column v-if="type === 1"
                                                                           :key="type"
                                                                           :prop="`before_${col.id}`"
                                                                           label="课前">
                                        <template v-slot="{row, column, $index}">
                                            <template v-if="isBatchEdit">
                                                    <span class="editable-batch-score"
                                                          :class="{'score-changed': row[`before_${col.id}`] !== row[`before_${col.id}_origin`]}"
                                                          @click="setBatchScore(row, column)">{{row[`before_${col.id}`]}}</span>
                                            </template>
                                            <span v-else class="score-popover-cell" :class="{'score-changed': row[`before_${col.id}`] !== row[`before_${col.id}_origin`]}"
                                                  @click.stop="showScorePopover(row, column, $event)">
                                                    {{row['before_' + col.id]}}
                                                    <img v-if="evaluationTypeList[evaluationTypeList.length - 1] === 1 && row[`status_${col.id}`]" class="inner-img" src="../assets/image/individualTeaching/three.png" alt="">
                                                </span>
                                        </template>
                                    </el-table-column>
                                        <el-table-column v-if="type === 1.5"
                                                         :key="type"
                                                         :prop="`finish_${col.id}`"
                                                         label="达成">
                                            <template v-slot="{row, column, $index}">
                                                <template v-if="isBatchEdit">
                                                    <span class="editable-batch-score"
                                                          :class="{'score-changed': row[`finish_${col.id}`] !== row[`finish_${col.id}_origin`]}"
                                                          @click="setBatchScore(row, column)">{{row[`finish_${col.id}`]}}</span>
                                                </template>
                                                <span v-else class="score-popover-cell" :class="{'score-changed': row[`finish_${col.id}`] !== row[`finish_${col.id}_origin`]}"
                                                      @click.stop="showScorePopover(row, column, $event)">
                                                    {{row['finish_' + col.id]}}
                                                    <img v-if="evaluationTypeList[evaluationTypeList.length - 1] === 1.5 && row[`status_${col.id}`]" class="inner-img" src="../assets/image/individualTeaching/three.png" alt="">
                                                </span>
                                            </template>
                                        </el-table-column>
                                        <el-table-column v-if="type === 2"
                                                         :key="type"
                                                         :prop="`work_${col.id}`"
                                                         label="作业">
                                            <template v-slot="{row, column, $index}">
                                                <img v-if="evaluationTypeList[evaluationTypeList.length - 1] === 2 && row[`status_${col.id}`]" class="inner-img" src="../assets/image/individualTeaching/three.png" alt="">
                                                <small-line-chart v-if="row[`work_${col.id}`] && row[`work_${col.id}`].length > 0"
                                                                  :score-list="row[`work_${col.id}`]"
                                                                  @click.native="showWorkInfo(row['id'], col['id'], row)"></small-line-chart>
                                                <div v-else style="width: 100%; height: 100%; cursor: pointer;" @click="showWorkInfo(row['id'], col['id'], row)"></div>
                                            </template>
                                        </el-table-column>
                                        <el-table-column v-if="type === 3"
                                                         :key="type"
                                                         :prop="`after_${col.id}`"
                                                         label="课后">
                                            <template v-slot="{row, column, $index}">
                                                <template v-if="isBatchEdit">
                                                    <span class="editable-batch-score"
                                                          :class="{'score-changed': row[`after_${col.id}`] !== row[`after_${col.id}_origin`]}"
                                                          @click="setBatchScore(row, column)">{{row[`after_${col.id}`]}}</span>
                                                </template>
                                                <span v-else class="score-popover-cell" :class="{'score-changed': row[`after_${col.id}`] !== row[`after_${col.id}_origin`]}"
                                                      @click.stop="showScorePopover(row, column, $event)">
                                                    {{row[`after_${col.id}`]}}
                                                    <img v-if="evaluationTypeList[evaluationTypeList.length - 1] === 3 && row[`status_${col.id}`]" class="inner-img" src="../assets/image/individualTeaching/three.png" alt="">
                                                </span>
                                            </template>
                                        </el-table-column>
                                        <el-table-column v-if="type === 4"
                                                         :key="type"
                                                         :prop="`end_${col.id}`"
                                                         label="期末">
                                            <template v-slot="{row, column, $index}">
                                                <template v-if="isBatchEdit">
                                                    <span class="editable-batch-score"
                                                          :class="{'score-changed': row[`end_${col.id}`] !== row[`end_${col.id}_origin`]}"
                                                          @click="setBatchScore(row, column)">{{row[`end_${col.id}`]}}</span>
                                                </template>
                                                <span v-else class="score-popover-cell" :class="{'score-changed': row[`end_${col.id}`] !== row[`end_${col.id}_origin`]}"
                                                      @click.stop="showScorePopover(row, column, $event)">
                                                    {{row[`end_${col.id}`]}}
                                                    <img v-if="evaluationTypeList[evaluationTypeList.length - 1] === 4 && row[`status_${col.id}`]" class="inner-img" src="../assets/image/individualTeaching/three.png" alt="">
                                                </span>
                                            </template>
                                        </el-table-column>
                                    </template>
                                </el-table-column>
                            </el-table>
                            <div v-if="isMoreBtnShown" class="more-row">
                                <div @click="showEvaluationMoreRow">
                                    <span>查看更多</span>
                                    <i v-if="!isMoreRowLoading" class="el-icon-arrow-down"></i>
                                    <i v-else class="el-icon-loading"></i>
                                </div>
                            </div>
                        </div>
                        <div v-if="isMoreColumnBtnShown" class="more-column">
                            <div @click="showEvaluationMoreColumn">
                                <i class="el-icon-arrow-right"></i>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="isBatchEdit" class="footer">
            <div>
                <div>
                    <span class="score" :class="{'selected': batchEditScoreIndex === 0}" @click="selectBatchEditScore(0)">0</span>
                    <span class="score" :class="{'selected': batchEditScoreIndex === 1}" @click="selectBatchEditScore(1)">1</span>
                    <span class="score" :class="{'selected': batchEditScoreIndex === 2}" @click="selectBatchEditScore(2)">2</span>
                    <span class="score" :class="{'selected': batchEditScoreIndex === 3}" @click="selectBatchEditScore(3)">3</span>
                    <span class="score" :class="{'selected': batchEditScoreIndex === 4}" @click="selectBatchEditScore(4)">4</span>
                </div>
                <div class="exit-batch-edit" @click="isBatchEdit = false">
                    <img src="../assets/image/individualTeaching/exit.png" alt="" />
                    <span>退出批量修改模式</span>
                </div>
            </div>
        </div>
        <el-dialog :visible.sync="isAddTargetDialogVisible"
                   :close-on-click-modal="false"
                   custom-class="add-target-dialog">
            <div class="title">加入教学目标</div>
            <div class="confirm-tip">是否将以下<span>{{batchTargetListComputed.length}}个</span>目标加入到<span>{{this.selectedGroup.join('、')}}</span>本学期的教学目标中？</div>
            <div class="table-header">
                <div>目标</div>
                <div>
                    <div>显示学生{{addTargetDialogScoreIndex === 0 ? '全部' : '课前评估平均值'}}<span v-if="addTargetDialogScoreIndex > 0" class="avg-score">≤{{addTargetDialogScoreIndex}}</span>的学习目标</div>
                    <div class="score">
                        <span :class="{'selected': addTargetDialogScoreIndex === 0}" @click="filterAddTargetScore(0)">全部</span>
                        <span :class="{'selected': addTargetDialogScoreIndex === 1}" @click="filterAddTargetScore(1)">1</span>
                        <span :class="{'selected': addTargetDialogScoreIndex === 2}" @click="filterAddTargetScore(2)">2</span>
                        <span :class="{'selected': addTargetDialogScoreIndex === 3}" @click="filterAddTargetScore(3)">3</span>
                        <span :class="{'selected': addTargetDialogScoreIndex === 4}" @click="filterAddTargetScore(4)">4</span>
                    </div>
                </div>
            </div>
            <div class="table-body">
                <div v-for="(item, index) of batchTargetListComputed" :key="item['id']" class="table-row">
                    <div>
                        <span>{{item['name']}}</span>
                        <span v-if="item['isTeachTarget']" class="tip">（已添加）</span>
                    </div>
                    <div>{{item['path']}}</div>
                    <div>
                        <img src="../assets/image/individualTeaching/circle-close.png" alt="" @click="removeBatchTargetItem(index)" />
                    </div>
                </div>
            </div>
            <div class="buttons">
                <div class="cancel-btn" @click="closeTargetListDialog">取消</div>
                <div class="confirm-btn" @click="addBatchTarget">确定</div>
            </div>
        </el-dialog>
        <div v-if="isWorkInfoPanelShown" class="work-info-panel">
            <div class="top">
                <span>{{workInfoStudentName}}同学过程反馈情况</span>
                <i class="el-icon-close" @click="closeWorkInfo"></i>
            </div>
            <div class="func-button">
                <div class="normal-button" @click="showAddEvaluate = true">增加评价</div>
                <div class="normal-button task" @click="showIframe">布置任务</div>
            </div>
            <div class="add-evaluate" v-if="showAddEvaluate">
                <div class="user-info">
                    <div class="user-icon">{{$userInfo.name.slice(0,1)}}</div>
                    <div class="user-name">{{$userInfo.name}}老师</div>
                </div>
                <div class="option-part">
                    <div class="left-word">{{evaluateName}}</div>
                    <div class="right-part">
                        <el-select v-model="sendEvaluateId" placeholder="请选择">
                            <el-option
                                    v-for="item in evaluateOptions"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <div class="button-part">
                    <div class="inner-button" @click="addTeacherEvaluate">确定</div>
                    <div class="inner-button" @click="showAddEvaluate = false">取消</div>
                </div>
            </div>
            <div class="work-info-container">
                <div v-for="(item, index) of workInfoList" :key="index" class="work-item">
                    <div class="header">
                        <div>
                            <img class="avatar" :src="item['photoUrl'] ? item['photoUrl'].replace('http://', 'https://') : require('../assets/image/individualTeaching/avatar.png')" alt="" />
                            <span>{{item['parentName']}}</span>
                        </div>
                        <div class="starts">
                            <template v-if="item['grade']">
                                <img v-for="(item, index) of new Array(item['grade']).fill('')" :key="index" src="../assets/image/individualTeaching/start.png" alt="" />
                            </template>
                        </div>
                    </div>
                    <div class="performance" v-if="item['description'] || item['fileList'].length > 0">
                        <div class="title" v-if="item['description']">
                            <i class="point"></i>
                            <span>{{item['description']}}</span>
                        </div>
                        <div class="images">
                            <el-image v-for="(file, index) in item['fileList'].filter(s => s['fileType'] === 2)"
                                      :key="'photo' + index"
                                      class="photo"
                                      :src="file['publicAddress2']"
                                      :preview-src-list="getWorkInfoImageSrcList(item['fileList'], index)">
                            </el-image>
                            <template v-for="(file, index) in item['fileList'].filter(s => s['fileType'] === 1)">
                                <div class="video" :key="'video' + index" @click="openWorkInfoVideoAudio(file['publicAddress'])">
                                    <img class="photo" :src="file['publicAddress2'] ? file['publicAddress2'].replace('http://', 'https://') : ``" alt="" />
                                    <i class="el-icon-caret-right"></i>
                                </div>
                            </template>
                            <template v-for="(file, index) in item['fileList'].filter(s => s['fileType'] === 4)">
                                <img src="../assets/image/individualTeaching/audio-icon.png" :key="'audio' + index" class="photo" alt="" @click="openWorkInfoVideoAudio(file['publicAddress'])" />
                            </template>
                        </div>
                    </div>
                    <div v-for="(target, index) of item['clockPunchItemResultVOs']" :key="target['name'] + target['value'] + index" class="target">
                        <div>{{target['itemName']}}</div>
                        <div>{{target['value']}}</div>
                    </div>
                    <div class="time-comment">
                        <div>{{item['clockPunchDay'] + ' ' + item['clockPunchTime'] | formatDate}}</div>
                        <div v-if="!item.parentName.includes('老师')">
                            <div>
                                <img src="../assets/image/individualTeaching/comment.png" alt="" />
                                <span>评论</span>
                            </div>
                            <div>
                                <img src="../assets/image/individualTeaching/thumb.png" alt="" />
                                <span>夸夸</span>
                            </div>
                        </div>
                    </div>
                    <div class="comments">
                        <div  v-if="item['praisePersonList'] && item['praisePersonList'].length > 0" class="thumbs">
                            <div class="thumb">
                                <img src="../assets/image/individualTeaching/thumb.png" alt="" />
                                <span>{{item['praisePersonList'].map(s => s['personName']).join(',')}}</span>
                            </div>
                        </div>
                        <div v-for="comment of item['commentVOs']" :key="comment['id']" class="comment">
                            <span>{{comment['replyPersonName']}}：</span>
                            <span>{{comment['commentDesc']}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="start-task" v-if="showStartTask">
            <div class="header"><i class="el-icon-close close" @click="showStartTask = false"></i></div>
            <iframe ref="mapFrame" class="inner-frame" :src="taskPath" frameborder="0"></iframe>
        </div>
        <el-popover v-model="isScorePopoverVisible" popper-class="score-popover">
            <div>
                <div v-for="option of scoreOptions"
                     :key="option['id']"
                     class="score-item"
                     @click="setSingleScore(option['value'])">{{option['value'] + ' ' + option['name']}}</div>
                <div class="my-goal">
                    <el-checkbox v-model="checked" @change="changeSingleStatus(scorePopoverRow, scorePopoverColumn)">本学期教学目标</el-checkbox>
                </div>
            </div>
        </el-popover>
        <video-player v-model="showVideoPlayer" :play-url="workInfoVideoAudioUrl"></video-player>
        <transition name="student-growth">
<!--            <student-growth v-if="studentGrowthVisible" :student-id="studentGrowthStudentId" :student-name="studentGrowthStudentName" @close="studentGrowthVisible = false"></student-growth>-->
            <div class="student-growth" v-if="studentGrowthVisible" v-loading="isStudentGrowthLoading">
                <iframe :src="studentGrowthUrl" @load="onStudentGrowLoaded"></iframe>
            </div>
        </transition>
        <div class="for-draw">
            <el-drawer
                    :visible.sync="showDrawer"
                    :append-to-body="false"
                    :with-header="false">
                <div class="content">
                    <div class="header">
                        <div class="left">
                            {{pointName}}
                        </div>
                        <div class="right">
                            <i class="el-icon-close inner" @click="showDrawer = false"></i>
                        </div>
                    </div>
                    <div class="draw-checked" v-if="true">
                        <el-checkbox v-model="checkedDrawer" @change="handleCheckedChange">仅看本级文件</el-checkbox>
                    </div>
                    <!-- <div class="file-list" v-if="drawFileList.length > 0"> -->
                        <!-- <div class="file-item" v-for="(item, index) in drawFileList" :key="index"> -->
                            <!-- <img v-if="item.type === 7" @click="judgeFilePlay(item)" class="inner-img" src="../assets/image/curriculumEvaluation/audio.png" alt=""> -->
                            <!-- <img v-if="item.type === 4" @click="judgeFilePlay(item)" class="inner-img" src="../assets/image/curriculumEvaluation/video.png" alt=""> -->
<!--                            <img @click="judgeFilePlay(item)" class="inner-img" src="../assets/image/curriculumEvaluation/pic.png" alt="">-->
                            <!-- <el-image style="width: 19px; margin-right: 4px" v-if="item.type === 6" :ref="'file' + item.id" class="type-icon" :preview-src-list="[item.url]" :src="prePic"></el-image> -->
                            <!-- <img v-if="item.type !== 4 && item.type !== 6 && item.type !== 7" @click="judgeFilePlay(item)" class="inner-img" src="../assets/image/curriculumEvaluation/normal-file.png" alt=""> -->
                            <!-- <div class="name" @click="judgeFilePlay(item)">  -->
                                <!-- {{item.fileName}} -->
                            <!-- </div>  -->
                        <!-- </div> -->
                    <!-- </div> -->
                    <div class="file-type" v-if="drawFileList">
                        <div v-for="(type, index1) in drawFileList.files" :key="index1">
                            <div class="type-name"><div></div>{{ type.categoryName }}</div>
                            <div class="file-list" v-if="type.details && type.details.length > 0">
                                <div class="file-item" v-for="(item, index2) in type.details" :key="index2">
                                    <img v-if="item.type === 7" @click="judgeFilePlay(item)" class="inner-img" src="../assets/image/curriculumEvaluation/audio.png" alt="">
                                    <img v-if="item.type === 4" @click="judgeFilePlay(item)" class="inner-img" src="../assets/image/curriculumEvaluation/video.png" alt="">
        <!--                            <img @click="judgeFilePlay(item)" class="inner-img" src="../assets/image/curriculumEvaluation/pic.png" alt="">-->
                                    <el-image style="width: 19px; margin-right: 4px" v-if="item.type === 6" :ref="'file' + item.id" class="type-icon" :preview-src-list="[item.url]" :src="prePic"></el-image>
                                    <img v-if="item.type !== 4 && item.type !== 6 && item.type !== 7" @click="judgeFilePlay(item)" class="inner-img" src="../assets/image/curriculumEvaluation/normal-file.png" alt="">
                                    <div class="name" @click="judgeFilePlay(item)">
                                        {{item.fileName}}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <p></p>
                    <div>
                        <el-pagination
                            :current-page.sync="drawerCurrentPage"
                            @current-change="handleCurrentChange"
                            :page-size="drawerPageSize"
                            layout="prev, pager, next"
                            :total="totalFileCounts">
                        </el-pagination>
                    </div>
                </div>
            </el-drawer>
        </div>
    </div>
</template>

<script>
    import Head from '../components/Head'
    import debounce from '../config/public/debounce'
    import {groupBy, findLastIndex, findIndex} from 'lodash'
    import smallLineChart from './individualTeaching/components/smallLineChart'
    import {convertToHttps} from '../config/public/httpsConverter'
    import VideoPlayer from './TongTongWork/components/VideoPlayer'
    import format from '../config/public/DateFormat'

    export default {
        name: 'individualTeaching2',
        components: {VideoPlayer, Head, smallLineChart},
        data() {
            return {
                EvaluationColumnDisplayStep: 10,
                StorageTermKey: 'individualTeaching_term',
                StorageGroupKey: 'individualTeaching_group',
                StorageEvaluationTypeKey: 'individualTeaching_evaluationType',
                StorageLessNumKey: 'individualTeaching_lessNum',
                StorageGreaterNumKey: 'individualTeaching_greaterNum',
                StorageLessIndexKey: 'individualTeaching_lessIndex',
                StorageGreaterIndexKey: 'individualTeaching_greaterIndex',
                isTermInit: true,
                isGroupInit: true,
                isStudentInit: true,
                innerTabIndex: 0,
                publisherList: [], // 出版社列表
                gradeList: [], // 年级列表
                subjectId: '', // 当前选中学科的id
                publisherIndex: 0,
                gradeIndex: 0,
                searchText: '',
                treeProps: {
                    label: 'name',
                    children: 'zones',
                    isLeaf: 'leaf'
                },
                rootNode: null, // 根节点（此节点看不到，在所有可见的节点之上）
                activeNode: {}, // 当前选中的节点
                currentNode: null,
                currentResolve: null,
                nodeNameChain: [],
                nodeNameChainBackup: [],
                searchedKnowledgeList: [], // 知识点列表搜索结果
                selectedSearchItemIndex: -1, // 选中的搜索结果中的item index
                selectedGroup: [], // 选择的group
                groupList: [], // 分组
                studentList: [], // 学生
                originalStudentList: [], // 所有学生（不去重）
                allFilterStudentListIndex: 0, // 柱状图/折线图全部学生列表的index
                selectedTermName: '', // 选择的学期
                termList: [], // 学期
                evaluationTypeList: [], // 1：课前评估 2：作业反馈 3：课后评估  4：期末评估
                isFirstLoadTree: true, // 是否首次加载树
                chartTypeIndex: 0, // 选择的图形类型
                filterStudentIds: [], // 图形右边过滤出来的学号
                lessNum: 1,
                lessIndex: 0,
                lessList: [],
                greaterNum: 3,
                greaterIndex: 0,
                greaterList: [],
                isNoEvaluationChecked: false,
                isTeachingTarget: false,
                isLessNumSetterShown: false,
                isGreaterNumSetterShown: false,
                isMyTeachingGoalChecked: false,
                isNoEvaluatedGoalChecked: false,
                chartOriginalData: [],
                analysisTableData: [], // 目标分析表格数据
                analysisColumnList: [], // 目标分析表格中的列
                analysisPageSize: 50,
                evaluationPageSize: 20,
                analysisRowTotal: 0,
                analysisCurrentPage: 1,
                currentSort: {
                    columnId: '',
                    order: ''
                },
                defaultColumnSortOrder: ['ascending', 'descending', null],
                columnSortOrders: ['ascending', 'descending', null],
                evaluationColumnList: [], // 目标评估表格中的列
                evaluationTableData: [], // 目标评估表格数据
                evaluationTableCurrentPage: 1, // 目标评估表当前页
                isBatchEdit: false, // 是否批量修改
                batchEditScoreIndex: -1, // 批量修改分数index
                isMoreBtnShown: false, // 是否显示查看更多按钮
                isMoreRowLoading: false, // 是否加载更多行
                evaluationTableHeight: 300, // 目标评估表格高度
                isMinorAdjust: false, // 是否需要微调高度，用于目标评估表格，解决固定列显示样式错乱问题
                isAddTargetDialogVisible: false, // 是否显示批量添加教学目标弹框
                addTargetDialogScoreIndex: 0,
                batchTargetList: [], // 批量添加目标列表
                isWorkInfoPanelShown: false, // 是否显示作业情况（移动端UI）
                workInfoList: [], // 作业情况信息
                workInfoStudentName: '',
                isScorePopoverVisible: false, // 评分popover是否显示
                scorePopoverRow: {},
                scorePopoverColumn: {},
                analysisChart: null,
                evaluationColumnDisplayNum: 15,
                analysisTableHeight: 300,
                showVideoPlayer: false,
                workInfoVideoAudioUrl: '',
                isTreeLoaded: true, // 树是否加载完，首次加载完成时模拟点击根节点
                studentGrowthVisible: false,
                studentGrowthStudentId: '',
                studentGrowthStudentName: '',
                studentGrowthUrl: '',
                isStudentGrowthLoading: false,
                checked: false,
                currentSchoolYear: '',
                showDrawer: false, // 目标抽屉列表,
                checkedDrawer: true,
                drawerCurrentPage: 1,
                drawerPageSize: 20,
                totalFileCounts: 0,
                drawFileList: [],
                pointName: '',
                pointId: '',
                prePic: require('../assets/image/curriculumEvaluation/pic.png'),
                colorSelect: false,
                singleAverage: false,
                sendStudentList: [],
                evaluateId: '',
                evaluateName: '',
                evaluateOptions: [],
                sendEvaluateId: '',
                sendStudentId: '',
                showAddEvaluate: false,
                showStartTask: false,
                currentTargetId: '',
                currentStudentId: '',
                taskPath: '',
                chartMaxScore: 4
            }
        },
        computed: {
            tabIndex: {
                get () {
                    let index = localStorage.getItem('individualTeaching_tabIndex');
                    if (index === undefined && this.innerTabIndex !== undefined) {
                        localStorage.setItem('individualTeaching_tabIndex', this.innerTabIndex);
                    } else {
                        this.innerTabIndex = Number(index)
                    }
                    return this.innerTabIndex;
                },
                set (tabIndex) {
                    localStorage.setItem('individualTeaching_tabIndex', tabIndex);
                    this.innerTabIndex = tabIndex;
                }
            },
            isInit() {
                return this.isTermInit || this.isGroupInit || this.isStudentInit
            },
            debounceSearchTextChange() {
                return debounce(this.onSearchTextChanged, 500);
            },
            allFilterStudentList() {
                let allSelectedStudents = []

                this.originalStudentList.forEach(s => {
                    if (this.selectedGroupIds.includes(s['groupId']) || this.selectedStudentIds.includes(s['id'])) {
                        if (allSelectedStudents.findIndex(t => t['id'] === s['id']) < 0) {
                            allSelectedStudents.push(s)
                        }
                    }
                })

                if (allSelectedStudents.length !== 1) {
                    return [{
                        id: 0,
                        name: '全部学生'
                    }].concat(allSelectedStudents)
                }
                return allSelectedStudents
            },
            batchTargetListComputed() {
                if (this.batchTargetList) {
                    return this.batchTargetList.filter(s => this.addTargetDialogScoreIndex === 0 || +s.score <= this.addTargetDialogScoreIndex)
                }

                return []
            },
            selectedGroupIds() {
                return this.groupList.filter(group => this.selectedGroup.includes(group['name'])).map(item => item['id'])
            },
            selectedStudentIds() {
                return this.studentList.filter(student => this.selectedGroup.includes(student['name'])).map(item => item['id']) || []
            },
            selectedSchoolYear() {
                return this.termList.find(s => s.name === this.selectedTermName).schoolYear
            },
            selectedTermId() {
                return this.termList.find(s => s.name === this.selectedTermName).termId
            },
            evaluationColumnListComputed() {
                return this.evaluationColumnList.slice(0, this.evaluationColumnDisplayNum)
            },
            scoreOptions() {
                if (this.scorePopoverRow['options']) {
                    return this.scorePopoverRow['options'].concat({
                        id: '0',
                        name: '空',
                        value: ''
                    })
                } else {
                    return []
                }
            },
            // 是否显示查看更多列按钮
            isMoreColumnBtnShown() {
               return this.evaluationColumnList.length > this.evaluationColumnListComputed.length
            }
        },
        watch: {
            studentGrowthVisible(val) {
                this.isStudentGrowthLoading = val
            },
            // 监听学科切换
            '$store.state.subjectActive': function() {
                this.clearContent()
                this.init();
            },
            selectedTermName(val) {
                localStorage.setItem(this.StorageTermKey, val)
            },
            selectedGroup(val) {
                localStorage.setItem(this.StorageGroupKey, JSON.stringify(val))

                if (val && val.length === 0) {
                    this.allFilterStudentListIndex = 0
                    this.filterStudentIds = []
                    this.analysisColumnList = []
                    this.evaluationColumnList = []
                    this.analysisTableData = []
                    this.evaluationTableData = []
                    this.isMoreBtnShown = false
                    this.chartOriginalData = []

                    if (this.analysisChart) {
                        this.analysisChart.dispose()
                    }
                }
            },
            searchText(value) {
                if (value === '') {
                    this.selectedSearchItemIndex = -1;
                }

                this.debounceSearchTextChange();
            },
            analysisCurrentPage(val) {
                this.getAnalysisTableData(val)
            },
            isBatchEdit() {
                this.adjustEvaluationTableHeight(true)
            },
            isNoEvaluationChecked() {
                this.$nextTick(() => {
                    this.drawChart()
                })
            },
            isTeachingTarget() {
                this.getAnalysisOverviewData()
            },
            singleAverage () {
                this.$nextTick(() => {
                    this.getAnalysisOverviewData()
                })
            }
        },
        created() {
            this.lessList = ['小于等于', '小于']
            this.greaterList = ['大于等于', '大于']
            this.getTermList()
            this.getGroupList()
            this.getStudentList()
        },
        mounted() {
            const storageEvaluationType = localStorage.getItem(this.StorageEvaluationTypeKey)
            const storageLessNum = localStorage.getItem(this.StorageLessNumKey)
            const storageGreaterNum = localStorage.getItem(this.StorageGreaterNumKey)
            const storageLessIndex = localStorage.getItem(this.StorageLessIndexKey)
            const storageGreaterIndex = localStorage.getItem(this.StorageGreaterIndexKey)

            this.evaluationTypeList = [1, 3]

            if (storageEvaluationType) {
                const evaluationTypeList = JSON.parse(storageEvaluationType)

                if (evaluationTypeList.length > 0) {
                    this.evaluationTypeList = evaluationTypeList
                }
            }

            if (storageLessNum) {
                this.lessNum = +storageLessNum
            }

            if (storageGreaterNum) {
                this.greaterNum = +storageGreaterNum
            }

            if (storageLessIndex) {
                this.lessIndex = +storageLessIndex
            }

            if (storageGreaterIndex) {
                this.greaterIndex = +storageGreaterIndex
            }

            this.adjustAnalysisTableHeight()
            this.adjustEvaluationTableHeight()
            window.addEventListener('resize', this.adjustEvaluationTableHeight)
            window.addEventListener('resize', this.adjustAnalysisTableHeight)
            document.body.addEventListener('click', this.closeScorePopover)
            window.addEventListener('message', this.closeStudentGrowth)
        },
        beforeDestroy() {
            window.removeEventListener('resize', this.adjustEvaluationTableHeight)
            window.removeEventListener('resize', this.adjustAnalysisTableHeight)
            document.body.removeEventListener('click', this.closeScorePopover)
            window.removeEventListener('message', this.closeStudentGrowth)
        },
        methods: {
            async init() {
                this.subjectId = localStorage.getItem('subjectId');
                this.clearTreeNode();
                // await Promise.all([this.getPublisherList(), this.getGradeList()]);
                this.loadNode(this.currentNode, this.currentResolve);
                this.loadDefaultData()
            },
            // 切换tab
            switchTab(index) {
                this.tabIndex = index
                this.queryDetail()
            },
            // 页面首次加载或切换学科时点击树的根节点
            loadDefaultData() {
                let count = 0
                const intervalId = setInterval(() => {
                    ++count

                    if (this.isTreeLoaded && !this.isInit) {
                        clearInterval(intervalId)
                        this.clickRootNode()
                    }

                    if (count > 20) {
                        clearInterval(intervalId)
                    }
                }, 500)
            },
            // 获取出版社
            getPublisherList() {
                return this.$https.get('/api/tk/chapter/edition/list').then(response => {
                    if (response['code'] !== 0) return;

                    const data = response['data'];

                    if (!data || data.length === 0) return;

                    this.publisherList = data;

                    // 记住选择的出版社
                    const publisherId = localStorage.getItem('publisherId');
                    if (publisherId) {
                        const publisherIndex = this.publisherList.findIndex(s => s['id'] === publisherId)
                        if (publisherIndex > -1) {
                            this.publisherIndex = publisherIndex;
                        }
                    }
                }).catch(error => {
                    this.$notify.error({
                        title: '错误',
                        message: error.message || error.data.message,
                    });
                });
            },
            // 获取年级
            getGradeList() {
                return this.$https.get('/api/tk/chapter/grades').then(response => {
                    if (response['code'] !== 0) return;

                    const data = response['data'];

                    if (!data || data.length === 0) return;

                    this.gradeList = data;

                    // 去除重复id的数据
                    let gradeMap = new Map();
                    this.gradeList.forEach(s => {
                        gradeMap.set(s['id'], s)
                    });
                    this.gradeList = Array.from(gradeMap.values());

                    // 记住选择的年级
                    const gradeId = localStorage.getItem('gradeId');
                    if (gradeId) {
                        const gradeIndex = this.gradeList.findIndex(s => s['id'] === gradeId)
                        if (gradeIndex > -1) {
                            this.gradeIndex = gradeIndex;
                        }
                    }
                }).catch(error => {
                    this.$notify.error({
                        title: '错误',
                        message: error.message || error.data.message,
                    });
                });
            },
            // 切换出版社
            changePublisher(index) {
                this.publisherIndex = index;
                localStorage.setItem('publisherId', this.publisherList[this.publisherIndex]['id']);
                this.clearTreeNode();
                this.loadNode(this.currentNode, this.currentResolve);
            },
            // 切换年级
            changeGrade(index) {
                this.gradeIndex = index;
                localStorage.setItem('gradeId', this.gradeList[this.gradeIndex]['id']);
                this.clearTreeNode();
                this.loadNode(this.currentNode, this.currentResolve);
            },
            // 获取学期
            getTermList() {
                this.$https.get('/api/tk/qbotTeach/selectSchoolYearAndTerms').then(response => {
                    if (response['code'] !== 0 || !response['data']) return
                    this.termList = response['data']
                    this.selectedTermName = this.termList[0].name

                    this.currentSchoolYear = this.termList[0].name

                    if (this.isInit) {
                        /*
                        const storageTermName = localStorage.getItem(this.StorageTermKey)

                        if (storageTermName && this.termList.find(s => s.name === storageTermName)) {
                            this.selectedTermName = storageTermName
                        }
                        */
                        // 取最新的学期
                        this.selectedTermName = this.termList && this.termList[0].name
                    }

                    this.isTermInit = false
                }).catch(error => {
                    console.error(error)
                    this.$notify.error({
                        title: '错误',
                        message: error.message || error.data.message,
                    })
                })
            },
            // 获取小组列表
            getGroupList() {
                this.$https.get('/api/tk/qbotTeach/group/list', {
                    params: {
                        pageNum: 1,
                        pageSize: 200,
                        subjectId: this.subjectId,
                    }
                }).then(response => {
                    if (response['code'] !== 0) return;

                    const data = response['data'];

                    if (!data || !data['data'] || data['data'].length === 0) {
                        this.groupList = [];
                        return;
                    }

                    this.groupList = data['data'];

                    if (this.isInit && !this.isStudentInit) {
                        const storageGroup = localStorage.getItem(this.StorageGroupKey)

                        if (storageGroup) {
                            const groupList = JSON.parse(storageGroup)
                            const list = this.groupList.concat(this.studentList)
                            this.selectedGroup.push(...groupList.filter(s => list.findIndex(t => t.name === s) >= 0))
                        }
                    }

                    this.isGroupInit = false
                }).catch(error => {
                    console.error(error)
                    this.$notify.error({
                        title: '错误',
                        message: error.message || error.data.message,
                    });
                });
            },
            // 获取学生列表
            getStudentList() {
                this.$https.get('/api/tk/qbotTeach/student/list', {
                    params: {
                        subjectId: this.subjectId,
                        pageNum: 1,
                        pageSize: 500
                    }
                }).then(response => {
                    if (response['code'] !== 0 || !response['data']) return
                    const data = response['data']
                    if (data.data) {
                        let studentList = []

                        this.originalStudentList = data.data.map(s => ({
                            id: s.id,
                            name: s.name,
                            groupId: s.groupId
                        }))
                        this.originalStudentList.forEach(s => {
                            if (studentList.findIndex(t => t.id === s.id) < 0) {
                                studentList.push(s)
                            }
                        })
                        this.studentList = studentList

                        if (this.isInit && !this.isGroupInit) {
                            const storageGroup = localStorage.getItem(this.StorageGroupKey)

                            if (storageGroup) {
                                const groupList = JSON.parse(storageGroup)
                                const list = this.groupList.concat(this.studentList)
                                this.selectedGroup.push(...groupList.filter(s => list.findIndex(t => t.name === s) >= 0))
                            }
                        }

                        this.isStudentInit = false
                    }
                }).catch(error => {
                    this.$notify.error({
                        title: '错误',
                        message: error.message || error.data.message,
                    })
                })
            },
            // 清空树节点
            clearTreeNode() {
                try {
                    if (this.$refs.tree && this.$refs.tree.$children.length > 0) {
                        this.$refs.tree.$children.forEach(item => {
                            this.$refs.tree.remove(item.node.data.id);
                        });
                    }
                } catch(ex) {
                    console.log(ex);
                }
            },
            // 加载树节点
            loadNode (node, resolve) {
                let params = null;
                let {level} = node;
                let url = '';
                let httpRequest = null;
                if (level === 0) {
                    this.currentNode = node;
                    this.currentResolve = resolve;

                    if (!this.rootNode) {
                        this.rootNode = node
                    }
                }

                if (this.isFirstLoadTree) {
                    this.isFirstLoadTree = false; // 防止重复加载
                    return;
                }

                this.isFirstLoadTree = false; // 防止重复加载

                const data = node['data'];

                if (level === 0) {
                    url = '/api/conn/clock/punch/pkg/pkgInfo';
                } else {
                    url = '/api/conn/clock/punch/pkg/selectPkgItems';
                }

                if (level === 0) {
                    params = {
                        subjectId: this.subjectId
                    };
                } else if (level === 1) {
                    params = {
                        parentId: 0,
                        pkgId: data ? data['id'] : 0,
                        catalogType: 1,
                        subjectId: this.subjectId
                    };
                } else {
                    params = {
                        parentId: data ? data['id'] : 0,
                        pkgId: data ? data['pkgId'] : 0,
                        catalogType: 1,
                        subjectId: this.subjectId
                    };
                }

                this.isTreeLoaded = false
                httpRequest = this.httpRequest('get', url, params);
                httpRequest.then(response => {
                    if (response['code'] !== 0) return;

                    const data = response['data'];

                    if (!data || data.length === 0) {
                        resolve([]);
                        return;
                    }

                    let nodes = [];

                    for (const item of data) {
                        if (level === 0) {
                            nodes.push({
                                id: item['id'],
                                value: item['id'],
                                name: item['name'],
                                label: item['name'],
                                leaf: false,
                                depth: level + 1,
                                disabled: false,
                            });
                        } else {
                            if (item['hasChild'] || (!item['hasChild'] && item['catalogType'] === 1)) { // 不显示最后的节点
                                nodes.push({
                                    id: item['id'],
                                    value: item['id'],
                                    name: item['name'],
                                    label: item['name'],
                                    leaf: Reflect.has(item, 'catalogType') ? item['catalogType'] === 1 && !item['hasChild'] : !item['hasChild'],
                                    depth: level + 1,
                                    disabled: false,
                                    pkgId: item['pkgId'],
                                });
                            }
                        }
                    }

                    resolve(nodes);
                    this.isTreeLoaded = true
                }).catch(error => {
                    this.$notify.error({
                        title: '错误',
                        message: error.message || error.data.message,
                    });
                });
            },
            httpRequest(method, url, params) {
                if (method.toLowerCase() === 'get') {
                    return this.$https.get(url, {
                        params: params
                    });
                }

                if (method.toLowerCase() === 'post') {
                    return this.$https.post(url, params);
                }

                return new Promise(resolve => resolve());
            },
            // 在面包屑上跳转到指定目录节点
            jump2Node(nodeId, index) {
                if (!nodeId) return

                this.activeNode = {
                    id: nodeId
                }
                this.nodeNameChainBackup = this.nodeNameChainBackup.slice(0, index + 1)
                this.queryDetail()
                this.removeSelectedStatus()
            },
            // 在图中向下钻取节点信息
            drillDownNode(nodeId, nodeName) {
                if (!nodeId) return

                this.activeNode = {
                    id: nodeId
                }
                this.nodeNameChainBackup.push({
                    id: nodeId,
                    name: nodeName
                })
                this.queryDetail()
                this.removeSelectedStatus()
            },
            // 移除树中选中状态
            removeSelectedStatus() {
                const currentElement = this.$refs.tree.$el.querySelector('.is-current')

                if (currentElement) {
                    currentElement.className = currentElement.className.replace('is-current', '')
                }
            },
            // 树节点点击
            handleNodeClick (data) {
                if (data.disabled) {
                    this.$refs.tree.setCurrentNode(this.activeNode);
                    return
                }

                const id = data.id
                const nodesMap = this.currentNode.store.nodesMap[id]
                const depth = data['depth'];
                let url = '';
                let params = {};
                let httpRequest = null;
                this.nodeNameChainBackup = []
                this.activeNode = data;
                this.selectedKnowledgeContent = data['label'];

                 if (this.rootNode.childNodes.length > 0) {
                     // 如果当前选中的节点不是第一层的节点，则取消“我的教学目标”选中状态
                     if (!this.rootNode.childNodes.some(t => t.data.id === this.currentNode.store.currentNode.data.id)) {
                        this.isMyTeachingGoalChecked = false
                     }
                 }

                for (let node = nodesMap; node.data && node.data.name; node = node.parent) {
                    this.nodeNameChainBackup.push({
                        id: node.data.id,
                        name: node.data.name
                    })
                }

                this.nodeNameChainBackup = this.nodeNameChainBackup.reverse()

                if (depth === 1) {
                    url = '/api/conn/clock/punch/pkg/pkgInfo';
                    params = {
                        parentId: 0,
                        pkgId: data ? data['id'] : 0,
                    }
                } else {
                    url = '/api/conn/clock/punch/pkg/selectPkgItems';
                    params = {
                        parentId: data ? data['id'] : 0,
                        pkgId: data ? data['pkgId'] : 0,
                        catalogType: 1,
                    };
                }

                httpRequest = this.httpRequest('get', url, params);
                httpRequest.then(response => {
                    if (response['code'] !== 0) return;

                    if (this.selectedGroup && this.selectedGroup.length > 0) {
                        this.queryDetail();
                    }

                }).catch(error => {
                    this.$notify.error({
                        title: '错误',
                        message: error.message || error.data.message,
                    });
                });

                // this.getScoreScope()
            },
            onSearchTextChanged() {
                let url = '';
                let params = {};
                let httpRequest = null;

                if (this.searchText.trim() === '') {
                    this.searchedKnowledgeList = []
                    return;
                }

                url = '/api/conn/clock/punch/pkg/searchItem';
                params = {
                    subjectId: this.subjectId,
                    limit: 200,
                    query: this.searchText.trim(),
                    catalogType: 1
                };
                httpRequest = this.httpRequest('get', url, params);
                httpRequest.then(response => {
                    if (response['code'] !== 0) return;
                    const data = response['data'];
                    if (!data || data.length === 0) {
                        this.searchedKnowledgeList = [];
                    }

                    this.searchedKnowledgeList = data;
                }).catch(error => {
                    this.$notify.error({
                        title: '错误',
                        message: error.message || error.data.message,
                    });
                });
            },
            onSearchedItemClick(item, index) {
                this.selectedSearchItemIndex = index;
                this.nodeNameChainBackup = item['name'].includes('-') ? item['name'].split('-').map(s => ({
                    id: '',
                    name: s
                })) : [{
                    id: '',
                    name: item['name']
                }]
                this.activeNode = {}
                this.activeNode.id = item['id']

                if (this.selectedGroup && this.selectedGroup.length > 0) {
                    this.queryDetail();
                }
            },
            selectEvaluationType(type) {
                if (!this.evaluationTypeList.includes(type)) {
                    this.evaluationTypeList.push(type)
                } else {
                    this.evaluationTypeList.splice(this.evaluationTypeList.findIndex(s => s === type), 1)
                }

                this.evaluationTypeList = this.evaluationTypeList.sort()

                if (this.tabIndex === 0) {
                    this.drawChart()
                }

                if (this.tabIndex === 1) {
                    this.adjustEvaluationTableHeight(true)
                }

                localStorage.setItem(this.StorageEvaluationTypeKey, JSON.stringify(this.evaluationTypeList))
            },
            // 查询
            queryDetail() {
                this.$nextTick(() => {
                    // 清空排序状态
                    this.currentSort = {}
                    if (this.tabIndex === 0) {
                        this.getAnalysisOverviewData()
                        this.getAnalysisTableData()
                    }

                    if (this.tabIndex === 1) {
                        this.getEvaluationTableData()
                    }
                })
            },
            getAnalysisOverviewData() {
                let groupIds = this.selectedGroupIds
                let studentIds = this.selectedStudentIds

                if (this.filterStudentIds && this.filterStudentIds.length) {
                    groupIds = []
                    studentIds = this.filterStudentIds
                }

                if (!this.activeNode
                    || !this.activeNode.id
                    || (groupIds.length === 0 && studentIds.length === 0)
                    || !this.selectedSchoolYear
                    || !this.selectedTermId) return

                let params = {
                    itemId: this.activeNode.id,
                    groupIds: groupIds,
                    studentIds: studentIds,
                    subjectId: this.subjectId,
                    schoolYear: this.selectedSchoolYear,
                    termId: this.selectedTermId
                }

                if (this.singleAverage) {
                    params.showGroupAverage = true;
                    params.studentId = studentIds[0]
                    params.groupDetail = {groupIds: this.selectedGroupIds, studentIds: this.selectedStudentIds}
                }

                if (this.isTeachingTarget) {
                    params.myTeachTarget = true
                }

                this.nodeNameChain = Array.from(this.nodeNameChainBackup)
                this.$https.post('/api/tk/qbotTeach/analysis/node/overview', params).then(response => {
                    if (response['code'] !== 0 || !response['data']) {
                        this.chartOriginalData = []
                        return
                    }

                    this.chartOriginalData = response['data']
                    this.drawChart()
                }).catch(error => {
                    this.$notify.error({
                        title: '错误',
                        message: error.message || error.data.message,
                    });
                });
            },
            changeChartType(index) {
                this.chartTypeIndex = index
                this.drawChart()
            },
            getScoreScope () {
                if (!this.activeNode.pkgId) return;
                this.$https.get(`/api/tk/qbotTeach/manage/selectDefaultOptionItems`, {
                    params: {
                        pkgId: this.activeNode.pkgId
                    }
                }).then(res => {
                    const { code, data } = res

                    if (code === 0 && data) {
                        this.chartMaxScore = data.length || 4
                    }
                })
            },
            getBarChartData() {
                let dataset = []
                let category = ['目标']

                if (this.evaluationTypeList.includes(1)) category.push('课前评估')
                if (this.evaluationTypeList.includes(3)) category.push('课后评估')
                if (this.evaluationTypeList.includes(4)) category.push('期末评估')
                dataset.push(category)
                this.chartOriginalData.forEach(s => {
                    let row = [s['name']]
                    if (this.evaluationTypeList.includes(1)) row.push(s['targetScore'])
                    if (this.evaluationTypeList.includes(3)) row.push(s['afterClassScore'])
                    if (this.evaluationTypeList.includes(4)) row.push(s['teacherScore'])

                    if (this.isNoEvaluationChecked && row.slice(1).every(s => s == '')) {
                        return
                    }

                    dataset.push(row)
                })

                return dataset
            },
            getLineChartData() {
                let category = null
                let beforeData = null
                let afterData = null
                let endData = null

                category = this.chartOriginalData.map(s => s['name'])

                if (this.evaluationTypeList.includes(1)) {
                    beforeData = this.chartOriginalData.map(s => s['targetScore'])
                }

                if (this.evaluationTypeList.includes(3)) {
                    afterData = this.chartOriginalData.map(s => s['afterClassScore'])
                }

                if (this.evaluationTypeList.includes(4)) {
                    endData = this.chartOriginalData.map(s => s['teacherScore'])
                }

                if (this.isNoEvaluationChecked) {
                    // 记录当前类目下所有评分为空的index
                    let removeIndexList = []
                    for (let i = 0; i < category.length; i++) {
                        if ((beforeData && beforeData[i] == '' || !beforeData) && (afterData && afterData[i] == '' || !afterData) && (endData && endData[i] == '' || !endData)) {
                            removeIndexList.push(i)
                        }
                    }

                    category = category && category.filter((s, i) => !removeIndexList.includes(i))
                    beforeData = beforeData && beforeData.filter((s, i) => !removeIndexList.includes(i))
                    afterData = afterData && afterData.filter((s, i) => !removeIndexList.includes(i))
                    endData = endData && endData.filter((s, i) => !removeIndexList.includes(i))
                }

                return {
                    category,
                    beforeData,
                    afterData,
                    endData
                }
            },
            getSaveAsImgName () {
                let title = ''

                if (this.isTeachingTarget) {
                    title = '教学目标'
                } else {
                    title = this.nodeNameChain[this.nodeNameChain.length - 1].name

                    if (this.allFilterStudentList[this.allFilterStudentListIndex]) {
                        const name = this.allFilterStudentList[this.allFilterStudentListIndex].name

                        if (name) {
                            title += '_' + name
                        }
                    }

                    title += '_' + format.formatTime(Date.now(),'yyyyMMddHHmmss')
                }

                return title
            },
            drawBarChart() {
                let series = []
                const dataset = this.getBarChartData()
                let baseBar =  {
                    type: 'bar',
                    itemStyle: {
                        normal: {
                            barBorderRadius: [100, 100, 0, 0]
                        }
                    },
                    label: {
                        show: true,
                        position: 'top',
                        fontFamily: 'Alibaba-PuHuiTi-Medium',
                        fontSize: 12
                    },
                    barMaxWidth: 30,
                    barMinHeight: 5,
                    markLine: {
                        symbol: 'circle',
                        label: {
                            textStyle: {
                                color: '#666666'
                            }
                        },
                        data: [
                            {
                                type: 'average',
                                name: '平均线'
                            }
                        ]
                    }
                }

                if (this.selectedStudentIds.length === 1 || this.filterStudentIds.length === 1) {
                    baseBar =  {
                        type: 'bar',
                        itemStyle: {
                            normal: {
                                barBorderRadius: [100, 100, 0, 0]
                            }
                        },
                        label: {
                            show: true,
                            position: 'top',
                            fontFamily: 'Alibaba-PuHuiTi-Medium',
                            fontSize: 12
                        },
                        barMaxWidth: 30,
                        barMinHeight: 5,
                    }
                }

                if ((this.selectedStudentIds.length === 1 || this.filterStudentIds.length === 1) && this.singleAverage) {
                    let pic = require('../assets/image/individualTeaching/base-line.png');
                    let obj = {
                        type: 'line',
                        symbol: `image://${pic}`,
                        symbolSize: [30, 8],
                        label: {
                            show: false,
                            position: 'top',
                            textStyle: {
                                color: '#2D258B',
                            }
                        },
                        lineStyle: {
                            normal: {
                                width: 0
                            }
                        },
                        areaStyle: {
                            normal: {
                                color: 'none'
                            }
                        },
                    }

                    // 过滤掉会影响小组平均分横线偏移的评估类型（“达成目标”，“作业反馈”）
                    const evaluationTypeList = [...this.evaluationTypeList]
                    evaluationTypeList.remove(1.5)
                    evaluationTypeList.remove(2)

                    let beforeArr = this.chartOriginalData.map(item => item.averageTargetScore);
                    let obj1 = JSON.parse(JSON.stringify(obj))
                    obj1.name = '课前评估';
                    obj1.data = beforeArr;
                    if (evaluationTypeList.length === 2) {
                        obj1.symbolOffset = [-20, 0];
                    } else if (evaluationTypeList.length === 3) {
                        obj1.symbolOffset = [-40, 0];
                    } else {
                        obj1.symbolOffset = [0, 0];
                    }
                    let midArr = this.chartOriginalData.map(item => item.averageAfterClassScore);
                    let obj2 = JSON.parse(JSON.stringify(obj))
                    obj2.name = '课后评估';
                    obj2.data = midArr;
                    if (evaluationTypeList.length === 2) {
                        if (evaluationTypeList.indexOf(3) === 1) {
                            obj2.symbolOffset = [20, 0];
                        } else {
                            obj2.symbolOffset = [-20, 0];
                        }
                    } else {
                        obj2.symbolOffset = [0, 0];
                    }
                    let lastArr = this.chartOriginalData.map(item => item.averageTeacherScore);
                    let obj3 = JSON.parse(JSON.stringify(obj))
                    obj3.name = '期末评估';
                    obj3.data = lastArr;
                    if (evaluationTypeList.length === 2) {
                        obj3.symbolOffset = [20, 0];
                    } else if (evaluationTypeList.length === 3) {
                        obj3.symbolOffset = [40, 0];
                    } else {
                        obj3.symbolOffset = [0, 0];
                    }
                    this.evaluationTypeList.forEach(s => {
                        switch (s) {
                            case 1:
                                series.push(obj1);
                                break
                            case 3:
                                series.push(obj2);
                                break
                            case 4:
                                series.push(obj3);
                                break
                        }
                    })
                }
                let beforeBar = JSON.parse(JSON.stringify(baseBar))
                let afterBar = JSON.parse(JSON.stringify(baseBar))
                let endBar = JSON.parse(JSON.stringify(baseBar))

                beforeBar.itemStyle.normal.color = new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                    offset: 1, color: 'rgba(255, 203, 92, 0.58)'
                }, {
                    offset: 0, color: '#FF9C2F'
                }])
                afterBar.itemStyle.normal.color = new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                    offset: 1, color: 'rgba(190, 224, 255, 0.79)'
                }, {
                    offset: 0, color: '#50B5FF'
                }])
                endBar.itemStyle.normal.color = new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                    offset: 1, color: 'rgba(154, 145, 254, 0.54)'
                }, {
                    offset: 0, color: '#8E84FC'
                }])
                this.evaluationTypeList.forEach(s => {
                    switch (s) {
                        case 1:
                            series.push(beforeBar)
                            break
                        case 3:
                            series.push(afterBar)
                            break
                        case 4:
                            series.push(endBar)
                            break
                    }
                })

                let option = {
                    grid: {
                        top: 50,
                        right: 530,
                        bottom: 230,
                        left: 30
                    },
                    legend: {
                        show: false
                    },
                    tooltip: {},
                    title: {
                        show: false,
                        text: this.getSaveAsImgName()
                    },
                    toolbox: {
                        right: 530,
                        feature: {
                            saveAsImage: {
                                pixelRatio: 5
                            }
                        }
                    },
                    dataset: {
                        source: dataset
                    },
                    xAxis: {
                        type: 'category',
                        axisLine: {
                            lineStyle: {
                                color: '#E8E8E8'
                            }
                        },
                        axisLabel: {
                            textStyle: {
                                color: '#666666'
                            },
                            interval: 0,
                            rotate: -13
                        }
                    },
                    yAxis: {
                        axisLine: {
                            lineStyle: {
                                color: '#E8E8E8'
                            }
                        },
                        axisLabel: {
                            textStyle: {
                                color: '#666666'
                            }
                        },
                        axisTick: {
                            show: false
                        },
                        splitLine: {
                            lineStyle: {
                                color: '#E8E8E8'
                            }
                        },
                        min: 0,
                        max: this.chartMaxScore,
                        interval: 1
                    },
                    dataZoom: [
                        {
                            type: 'slider',
                            showDetail: false,
                            show: dataset.length > 20,
                            bottom: 160,
                            start: 0,
                            end: Math.round((20 / dataset.length) * 100)
                        }
                    ],
                    series: series
                }
                if (this.analysisChart) {
                    this.analysisChart.dispose()
                }

                this.analysisChart = this.$echarts.init(this.$refs.chart)
                this.analysisChart.setOption(option, true)
            },
            drawLineChart() {
                let {category, beforeData, afterData, endData} = this.getLineChartData()
                let series = []

                if (beforeData) {
                    series.push({
                        name: '课前评估',
                        type: 'line',
                        itemStyle: {
                            normal: {
                                color: '#F69D3F'
                            }
                        },
                        lineStyle: {
                            color: '#F69D3F',
                            shadowColor: '#F69D3F',
                            shadowOffsetY: 2,
                            shadowBlur: 10
                        },
                        markLine: {
                            symbol: 'circle',
                            label: {
                                textStyle: {
                                    color: '#666666'
                                }
                            },
                            data: [
                                {
                                    type: 'average',
                                    name: '平均线'
                                }
                            ]
                        },
                        data: beforeData
                    })
                }

                if (afterData) {
                    series.push({
                        name: '课后评估',
                        type: 'line',
                        itemStyle: {
                            normal: {
                                color: '#50B5FF'
                            }
                        },
                        lineStyle: {
                            color: '#50B5FF',
                            shadowColor: '#50B5FF',
                            shadowOffsetY: 2,
                            shadowBlur: 10
                        },
                        markLine: {
                            symbol: 'circle',
                            label: {
                                textStyle: {
                                    color: '#666666'
                                }
                            },
                            data: [
                                {
                                    type: 'average',
                                    name: '平均线'
                                }
                            ]
                        },
                        data: afterData
                    })
                }

                if (endData) {
                    series.push({
                        name: '期末评估',
                        type: 'line',
                        itemStyle: {
                            normal: {
                                color: '#8E84FC'
                            }
                        },
                        lineStyle: {
                            color: '#8E84FC',
                            shadowColor: '#8E84FC',
                            shadowOffsetY: 2,
                            shadowBlur: 10
                        },
                        markLine: {
                            symbol: 'circle',
                            label: {
                                textStyle: {
                                    color: '#666666'
                                }
                            },
                            data: [
                                {
                                    type: 'average',
                                    name: '平均线'
                                }
                            ]
                        },
                        data: endData
                    })
                }

                let option = {
                    grid: {
                        top: 50,
                        right: 530,
                        bottom: 230,
                        left: 30
                    },
                    title: {
                        show: false,
                        text: this.getSaveAsImgName()
                    },
                    tooltip: {},
                    toolbox: {
                        right: 530,
                        feature: {
                            saveAsImage: {
                                pixelRatio: 5
                            }
                        }
                    },
                    xAxis: {
                        type: 'category',
                        data: category,
                        axisLine: {
                            lineStyle: {
                                color: '#E8E8E8'
                            }
                        },
                        axisLabel: {
                            textStyle: {
                                color: '#666666'
                            },
                            interval: 0,
                            rotate: -13
                        }
                    },
                    yAxis: {
                        type: 'value',
                        axisLine: {
                            lineStyle: {
                                color: '#E8E8E8'
                            }
                        },
                        axisLabel: {
                            textStyle: {
                                color: '#666666'
                            }
                        },
                        axisTick: {
                            show: false
                        },
                        splitLine: {
                            lineStyle: {
                                color: '#E8E8E8'
                            }
                        },
                        min: 0,
                        max: this.chartMaxScore,
                        interval: 1
                    },
                    dataZoom: [
                        {
                            type: 'slider',
                            showDetail: false,
                            show: category.length > 20,
                            bottom: 160,
                            start: 0,
                            end: Math.round(20 / category.length * 100)
                        }
                    ],
                    series: series
                }

                if (this.analysisChart) {
                    this.analysisChart.dispose()
                }

                this.analysisChart = this.$echarts.init(this.$refs.chart)
                this.analysisChart.setOption(option, true)
            },
            drawChart() {
                if (this.tabIndex === 0) {
                    if (this.chartTypeIndex === 0) this.drawBarChart()
                    if (this.chartTypeIndex === 1) this.drawLineChart()

                    if (this.analysisChart) {
                        this.analysisChart.off('click')
                        this.analysisChart.on('click', 'series', event => {
                            const nodeData = this.chartOriginalData.find(s => s.name === event.name)
                            if (nodeData && nodeData.catalogType === 1) {
                                this.drillDownNode(nodeData.id, nodeData.name)
                            }
                        })
                    }
                }
            },
            // 柱状/折线图右边过滤学生
            filterStudent(index) {
                this.filterStudentIds = []
                this.allFilterStudentListIndex = index
                this.singleAverage = false
                if (index > 0) {
                    this.filterStudentIds = [this.allFilterStudentList[index]['id']]
                }

                if (index === 0) {
                    this.filterStudentIds = this.allFilterStudentList.map(s => s['id'])
                }

                this.getAnalysisOverviewData()

            },
            // 获取目标分析表数据
            getAnalysisTableData(pageNum = 1) {
                if (!pageNum || Number.isNaN(pageNum)) return

                let url = `/api/tk/qbotTeach/analysis/node/detail?pageNum=${pageNum}&pageSize=${this.analysisPageSize}`

                if (!this.activeNode
                    || !this.activeNode.id
                    || !this.subjectId
                    || (this.selectedGroupIds.length === 0 && this.selectedStudentIds.length === 0)
                    || !this.selectedSchoolYear
                    || !this.selectedTermId) return

                this.analysisColumnList = []
                this.analysisTableData = []

                let params = {
                    id: this.activeNode.id,
                    groupIds: this.selectedGroupIds,
                    studentIds: this.selectedStudentIds,
                    subjectId: this.subjectId,
                    schoolYear: this.selectedSchoolYear,
                    termId: this.selectedTermId
                }

                if (this.currentSort.order && this.currentSort.columnId) {
                    let [colName, targetId] = this.currentSort.columnId.split('_')
                    params['sortTargetId'] = targetId
                    params['orderBy'] = (() => {
                        switch(colName) {
                            case 'before':
                                return 'targetScore'
                            case 'after':
                                return 'afterClassScore'
                            case 'end':
                                return 'teacherScore'
                            default:
                                return ''
                        }
                    })()
                    params['sortBy'] = (() => {
                        switch(this.currentSort.order) {
                            case 'ascending':
                                return 'asc'
                            case 'descending':
                                return 'desc'
                            case 'end':
                                return null
                        }
                    })()
                }

                this.$https.post(url, params).then(response => {
                    this.analysisTableData = []

                    if (response['code'] !== 0 || !response['data']) return
                    let data = response['data']
                    this.analysisRowTotal = data['total']

                    if (!response['data']['data']) return
                    data = response['data']['data']
                    if (data.length === 0) return
                    this.analysisColumnList = data[0]['targetDetails'].map(s => ({
                        id: s.id,
                        name: s.name
                    }))
                    this.analysisTableData = data.map(s => {
                        let row = {
                            studentId: s.id,
                            name: s.name
                        };
                        s['targetDetails'].forEach(t => {
                            row['before_' + t.id] = t['targetScore']
                            row['after_' + t.id] = t['afterClassScore']
                            row['end_' + t.id] = t['teacherScore']
                            row['isTarget_' + t.id] = t.teachTarget
                        })
                        return row
                    })
                }).catch(error => {
                    this.$notify.error({
                        title: '错误',
                        message: error.message || error.data.message,
                    })
                })
            },
            sortChange(event) {
                this.currentSort = {
                    columnId: event['prop'],
                    order: event['order']
                }

                if (this.currentSort.order === 'ascending') {
                    this.columnSortOrders = this.defaultColumnSortOrder.slice(1).concat(this.defaultColumnSortOrder.slice(0, 1))
                }

                if (this.currentSort.order === 'descending') {
                    this.columnSortOrders = this.defaultColumnSortOrder.slice(-1).concat(this.defaultColumnSortOrder.slice(0, 2))
                }

                if (!this.currentSort.order) {
                    this.columnSortOrders = this.defaultColumnSortOrder
                }

                this.getAnalysisTableData(this.analysisCurrentPage)
            },
            setLessNum() {
                this.isLessNumSetterShown = false
                localStorage.setItem(this.StorageLessNumKey, this.lessNum)
                localStorage.setItem(this.StorageLessIndexKey, this.lessIndex)
            },
            setGreaterNum() {
                this.isGreaterNumSetterShown = false
                localStorage.setItem(this.StorageGreaterNumKey, this.greaterNum)
                localStorage.setItem(this.StorageGreaterIndexKey, this.greaterIndex)
            },
            setCellClassName({row, column}) {
                const cellValue = row[column['property']]

                if (!cellValue) {
                    return 'white'
                }

                if (this.colorSelect) {
                    if (cellValue < 1) {
                        return 'one'
                    } else if (cellValue < 2) {
                        return 'two'
                    } else if (cellValue < 3) {
                      return 'three'
                    } else if (cellValue < 4) {
                      return 'four'
                    } else if (cellValue < 5) {
                      return 'five'
                    } else if (cellValue < 6) {
                      return 'six'
                    } else if (cellValue < 7) {
                      return 'seven'
                    } else if (cellValue < 8) {
                      return 'eight'
                    } else {
                      return 'white'
                    }
                }

                if (!this.colorSelect) {
                    if (cellValue < 1) {
                        return 'one-light'
                    } else if (cellValue < 2) {
                        return 'two-light'
                    } else if (cellValue < 3) {
                        return 'three-light'
                    } else if (cellValue < 4) {
                        return 'four-light'
                    } else if (cellValue < 5) {
                        return 'five-light'
                    } else if (cellValue < 6) {
                        return 'six-light'
                    } else if (cellValue < 7) {
                        return 'seven-light'
                    } else if (cellValue < 8) {
                        return 'eight-light'
                    } else {
                        return 'white'
                    }
              }

                if (this.lessNum !== ''
                    && cellValue !== ''
                    && this.lessNum >= 0
                    && (this.lessIndex === 0 && +cellValue <= this.lessNum
                    || this.lessIndex === 1 && +cellValue < this.lessNum)) {
                    return 'blue'
                }

                if (this.greaterNum !== ''
                    && cellValue !== ''
                    && this.greaterNum >= 0
                    && (this.greaterIndex === 0 && +cellValue >= this.greaterNum
                    || this.greaterIndex === 1 && +cellValue > this.greaterNum)) {
                    return 'pink'
                }
            },
            // 调整分析表高度
            adjustAnalysisTableHeight() {
                this.$nextTick(() => {
                    this.analysisTableHeight = this.$refs.leftPart.clientHeight - 70
                })
            },
            // 调整目标评估表格高度
            adjustEvaluationTableHeight(needMinorAdjust = false) {
                this.$nextTick(() => {
                    this.evaluationTableHeight = this.$refs.leftPart.clientHeight - 20

                    if (this.isMoreBtnShown) {
                        this.evaluationTableHeight -= 40
                    }

                    // 如果不加下面的代码，表格固定列的样式会错乱
                    if (needMinorAdjust) {
                        if (this.isMinorAdjust) {
                            this.evaluationTableHeight -= 2
                        } else {
                            this.evaluationTableHeight += 2
                        }

                        this.isMinorAdjust = !this.isMinorAdjust
                    }
                })
            },
            // 修改sort顺序
            changeDefaultColumnSortOrder(event) {
                let targetElement = event.target

                if (targetElement.className.includes('cell')) {
                    targetElement = targetElement.offsetParent
                }

                let classList = Array.from(targetElement.classList)

                if (classList.includes('header-cell') && classList.includes('is-leaf')) {
                    const columnId = classList.find(s => s.startsWith('before_') || s.startsWith('after_') || s.startsWith('end_'))

                    if (this.currentSort.columnId === columnId) {
                        if (this.currentSort.order === 'ascending') {
                            this.columnSortOrders = this.defaultColumnSortOrder.slice(1).concat(this.defaultColumnSortOrder.slice(0, 1))// ['descending', null, 'ascending']
                        }

                        if (this.currentSort.order === 'descending') {
                            this.columnSortOrders = this.defaultColumnSortOrder.slice(-1).concat(this.defaultColumnSortOrder.slice(0, 2))// [null, 'ascending', 'descending']
                        }

                        if (!this.currentSort.order) {
                            this.columnSortOrders = this.defaultColumnSortOrder
                        }
                    }
                }
            },
            // 获取目标评估表数据
            getEvaluationTableData(pageNum = 1) {
                let url = `/api/tk/qbotTeach/appraise/node/overview?pageNum=${pageNum}&pageSize=${this.evaluationPageSize}`

                if (!this.activeNode
                    || !this.activeNode.id
                    || !this.subjectId
                    || (this.selectedGroupIds.length === 0 && this.selectedStudentIds.length === 0)
                    || !this.selectedSchoolYear
                    || !this.selectedTermId) return

                this.nodeNameChain = this.nodeNameChainBackup
                this.evaluationTableCurrentPage = pageNum
                this.$https.post(url, {
                    itemId: this.activeNode.id,
                    groupIds: this.selectedGroupIds,
                    studentIds: this.selectedStudentIds,
                    subjectId: this.subjectId,
                    schoolYear: this.selectedSchoolYear,
                    termId: this.selectedTermId,
                    myTeachTarget: this.isMyTeachingGoalChecked,
                    unAppraiseTarget: this.isNoEvaluatedGoalChecked
                }).then(response => {
                    if (response['code'] !== 0 || !response['data'] || (typeof response['data'] === 'object' && Object.keys(response['data']).length === 0)) {
                        if (pageNum === 1) {
                            this.evaluationColumnList = []
                            this.evaluationTableData = []
                        }

                        return
                    }

                    const data = response['data']['data']
                    if (!data || data.length === 0) return
                    this.evaluationColumnDisplayNum = this.EvaluationColumnDisplayStep
                    this.evaluationColumnList = data[0]['studentScore'].map(s => ({
                        id: s.id,
                        name: s.name
                    }))

                    const groups = groupBy(data, 'path')

                    if (pageNum === 1) {
                        this.evaluationTableData = []
                    }

                    Object.entries(groups).forEach(g => {
                        if (this.evaluationTableData.findIndex(s => Object.keys(s).length === 1 && s['name'] === g[0]) < 0) {
                            this.evaluationTableData.push({
                                name: g[0],
                            })
                        }

                        g[1].forEach(item => {
                            let row = {
                                id: item['targetId'],
                                name: item['targetName'],
                                isTarget: item['teachTarget'],
                                isCustomOrigin: item['isCustomized']
                            }

                            if (item['studentScore'].filter(item => item.teachTarget).length === item['studentScore'].length) {
                                row.targetStatus = 2
                            } else if (item['studentScore'].filter(item => item.teachTarget).length === 0) {
                                row.targetStatus = 0
                            } else {
                                row.targetStatus = 1
                            }

                            if (item['studentScore'] && item['studentScore'][0]) {
                                row['options'] = item['studentScore'][0]['options']
                            }

                            item['studentScore'].forEach(s => {
                                row[`before_${s['id']}`] = s['targetScore'] !== null ? s['targetScore'] : ''
                                row[`work_${s['id']}`] = s['scores'] || []
                                row[`after_${s['id']}`] = s['afterClassScore'] !== null ? s['afterClassScore'] : ''
                                row[`end_${s['id']}`] = s['teacherScore'] !== null ? s['teacherScore'] : ''
                                row[`before_${s['id']}_origin`] = s['targetScore'] !== null ? s['targetScore'] : ''
                                row[`after_${s['id']}_origin`] = s['afterClassScore'] !== null ? s['afterClassScore'] : ''
                                row[`end_${s['id']}_origin`] = s['teacherScore'] !== null ? s['teacherScore'] : ''
                                row[`status_${s['id']}`] = s['teachTarget']
                                row[`finish_${s['id']}`] = s['finishScore'] !== null ? s['finishScore'] : ''
                                row[`finish_${s['id']}_origin`] = s['finishScore'] !== null ? s['finishScore'] : ''
                            })
                            this.evaluationTableData.push(row)
                        })
                    })

                    const currentRowNum = this.evaluationTableData.length - this.evaluationTableData.filter(s => Object.keys(s).length === 1).length

                    if (response['data']['total'] > currentRowNum) {
                        this.isMoreBtnShown = true
                    } else {
                        this.isMoreBtnShown = false
                    }

                    this.adjustEvaluationTableHeight(true)

                    /* 横向滚动条到最右端再显示“显示更多列”按钮
                    const handleScrollXEvent = debounce(() => {
                        if (!this.$refs.evaluationTable) return

                        const bodyWrapper = this.$refs.evaluationTable.bodyWrapper
                        const tableElement = bodyWrapper.children[0]

                        if (bodyWrapper.scrollLeft + bodyWrapper.clientWidth >= tableElement.clientWidth) {
                            bodyWrapper.scrollLeft = tableElement.clientWidth - bodyWrapper.clientWidth

                            if (this.evaluationColumnList.length > this.evaluationColumnListComputed.length) {
                                this.isMoreColumnBtnShown = true
                            }
                        } else {
                            this.isMoreColumnBtnShown = false
                        }
                    }, 200)

                    this.$nextTick(() => {
                        this.$refs.evaluationTable.bodyWrapper.onscroll = handleScrollXEvent
                    })
                    */

                    if (this.isMoreRowLoading) {
                        this.$nextTick(() => {
                            this.$refs.evaluationTable.bodyWrapper.scrollTop = this.$refs.evaluationTable.bodyWrapper.scrollHeight
                        })
                        this.isMoreRowLoading = false
                    }
                }).catch(error => {
                    this.$notify.error({
                        title: '错误',
                        message: error.message || error.data.message,
                    })
                })
            },
            // 我的教学目标
            getMyTeachingGoals() {
                this.isMyTeachingGoalChecked = !this.isMyTeachingGoalChecked

                if (this.isMyTeachingGoalChecked) {
                    if (this.searchText) {
                        this.searchText = ''
                    }

                    this.$nextTick(() => {
                        setTimeout(() => {
                          if (this.nodeNameChain.length > 0) {
                            const index = this.rootNode.childNodes.findIndex(t => t.data.id === this.nodeNameChain[0].id)

                            if (~index) {
                              this.clickFirstLevelNode(index)
                            }
                          } else {
                            this.clickRootNode()
                          }
                        }, 500)
                    })
                } else {
                    this.getEvaluationTableData(1)
                }
            },
            // 点击第一层节点
            clickFirstLevelNode(index) {
              let element = document.querySelectorAll('.el-tree > .el-tree-node')[index]

              if (element) {
                element = element.querySelector('.el-tree-node__content')

                if (element) {
                  element.click()
                }
              }
            },
            // 点击根节点（此根节点为可见的第一个节点）
            clickRootNode() {
                let rootElement = document.querySelector('.el-tree > .el-tree-node > .el-tree-node__content')

                if (rootElement) {
                    rootElement.click()
                }
            },
            // 未评估目标
            getUnevaluatedGoals() {
                this.isNoEvaluatedGoalChecked = !this.isNoEvaluatedGoalChecked
                this.getEvaluationTableData(1)
            },
            // 在表格中设置目标组的colspan
            evaluationTableSpanMethod({row, columnIndex}) {
                const keys = Object.keys(row)
                if (keys.length === 1 && keys[0] === 'name' && columnIndex === 2) {
                    return [1, this.evaluationTypeList.length * this.evaluationColumnListComputed.length]
                } else {
                    return [1, 1]
                }
            },
            evaluationCellMethod({row}) {
                let className = 'evaluation-cell '
                const keys = Object.keys(row)

                if (keys.length === 1 && keys[0] === 'name') {
                    className += 'target-path-row'
                }

                return className
            },
            // 添加自定义目标
            addCustomTarget(index) {
                let currentIndex = index
                // 下一组开始的index
                let afterIndex = this.evaluationTableData.findIndex((r, i) => i > currentIndex && Object.keys(r).length === 1)
                let row = {
                    name: '',
                    isCustom: true
                }

                if (this.evaluationTableData.length > 1) {
                    const nonCustomRow = this.evaluationTableData.find(s => !s.isCustom && !s.isCustomOrigin && Object.keys(s).length > 1)
                    Object.keys(nonCustomRow).forEach(key => {
                        if (key !== 'name' && key !== 'isCustom' && key !== 'isTarget' && key !== 'isCustomOrigin') {
                            row[key] = ''
                        }
                    })
                }

                if (afterIndex < 0) {
                    this.evaluationTableData.push(row)
                } else {
                    this.evaluationTableData.splice(afterIndex, 0, row)
                }
            },
            // 保存自定义目标
            saveCustomTarget(row, index, ref) {
                this.setCustomTarget(row, index, this.$refs[ref].value)
            },
            // 重命名自定义目标名称
            renameCustomTargetName(row, index) {
                this.$set(row, 'isCustom', true)
                this.$set(row, 'isCustomOrigin', false)
                row['isRename'] = true
                this.$nextTick(() => {
                    this.$refs[`targetName${index}`].focus()
                    this.$refs[`targetName${index}`].value = row['name']
                })
            },
            setCustomTarget(row, index, value) {
                let url = `/api/tk/qbotTeach/appraise/customizedTarget/add`
                let name = value
                let prevNonCustomTargetIndex = -1 // 上一个非自定义目标的index
                let nextNonCustomTargetIndex = -1 // 下一个非自定义目标的index
                let itemId = ''

                if (!name
                    || !this.subjectId
                    || (this.selectedGroupIds.length === 0 && this.selectedStudentIds.length === 0)
                    || !this.selectedSchoolYear
                    || !this.selectedTermId) return

                prevNonCustomTargetIndex = findLastIndex(this.evaluationTableData, r => !r.isCustomOrigin && !r.isCustom && Object.keys(r).length > 1, index - 1)

                if (prevNonCustomTargetIndex < 0) {
                    nextNonCustomTargetIndex = findIndex(this.evaluationTableData, r => !r.isCustomOrigin && !r.isCustom && Object.keys(r).length > 1, index)
                }

                itemId = prevNonCustomTargetIndex > -1 ? this.evaluationTableData[prevNonCustomTargetIndex]['id'] : this.evaluationTableData[nextNonCustomTargetIndex]['id']

                if (row['isRename']) {
                    url = `/api/tk/qbotTeach/appraise/customizedTarget/rename`
                    itemId = row['id']
                }

                this.$set(row, 'isCustom', false)
                this.$set(row, 'isCustomOrigin', true)
                row['name'] = name
                this.$https.post(url, {
                    itemId,
                    itemName: name,
                    groupIds: this.selectedGroupIds,
                    studentIds: this.selectedStudentIds,
                    subjectId: this.subjectId,
                    schoolYear: this.selectedSchoolYear,
                    termId: this.selectedTermId
                }).then(response => {
                    if (response['code'] !== 0) return
                    if (!row['isRename']) {
                        row['id'] = response['data']
                        row['options'] = prevNonCustomTargetIndex > -1 ? this.evaluationTableData[prevNonCustomTargetIndex]['options'] : this.evaluationTableData[nextNonCustomTargetIndex]['options']
                        this.sortCurrentGroupTargetList(row, index)
                    }
                    this.markNow(row, true)

                }).catch(error => {
                    this.$notify.error({
                        title: '错误',
                        message: error.message || error.data.message,
                    })
                })
            },
            // 对当前组的目标排序
            sortCurrentGroupTargetList(row, index) {
                // 当前组开始的index
                let currentGroupIndex = -1
                // 下一组开始的index
                let nextGroupIndex = -1

                for (let i = 0; i < this.evaluationTableData.length; i++) {
                    const keys = Object.keys(this.evaluationTableData[i])

                    if (keys.length === 1 && keys[0] === 'name') {
                        if (i < index) {
                            currentGroupIndex = i
                        } else if (i > index) {
                            nextGroupIndex = i
                            break
                        }
                    }
                }

                let targets = nextGroupIndex > -1 ? this.evaluationTableData.slice(currentGroupIndex + 1, nextGroupIndex) : this.evaluationTableData.slice(currentGroupIndex + 1)
                const reg = /^((\d\.?)+).*/
                targets.sort((a, b) => {
                    let matchA = a.name.match(reg)
                    let matchB = b.name.match(reg)

                    if (!matchA || !matchA[1]) {
                        return -1
                    }

                    if (!matchB || !matchB[1]) {
                        return 1
                    }

                    if (matchA && matchB && matchA[1] && matchB[1]) {
                        let numArrA = matchA[1].split('.')
                        let numArrB = matchB[1].split('.')

                        for (let i = 0; i < Math.min(numArrA.length, numArrB.length); i++) {
                            if (+numArrA[i] === +numArrB[i]) {
                                continue
                            }

                            return +numArrA[i] - +numArrB[i]
                        }

                        return matchA[1].localeCompare(matchB[1])
                    }

                    return 0
                })

                // 名字非空的目标
                const nonEmptyTargets = targets.filter(s => s.name.trim() !== '')

                if (currentGroupIndex > -1) {
                    this.evaluationTableData.splice(currentGroupIndex + 1, targets.length, ...nonEmptyTargets)
                }
            },
            // 删除自定义目标
            removeCustomTarget(row, index) {
                this.$confirm('确定要删除此自定义目标吗？').then(() => {
                    let url = '/api/tk/qbotTeach/appraise/customizedTarget/remove'

                    if (!this.subjectId
                        || (this.selectedGroupIds.length === 0 && this.selectedStudentIds.length === 0)
                        || !this.selectedSchoolYear
                        || !this.selectedTermId) return

                    this.evaluationTableData.splice(index, 1)

                    if (!row['id']) return

                    this.$https.post(url, {
                        itemId: row['id'],
                        itemName: '',
                        groupIds: this.selectedGroupIds,
                        studentIds: this.selectedStudentIds,
                        subjectId: this.subjectId,
                        schoolYear: this.selectedSchoolYear,
                        termId: this.selectedTermId,
                    }).then(response => {
                        if (response['code'] !== 0) return
                    }).catch(error => {
                        this.$notify.error({
                            title: '错误',
                            message: error.message || error.data.message,
                        })
                    })
                })
            },
            // 标记为本学期教学目标
            markTarget(row) {
                row['isTarget'] = true;
                row['targetStatus'] = 2;
                this.markNow(row, true);
                this.updateTarget([row['id']], true)
            },
            // 自定义目标出现小三角
            markNow (row, status) {
              Object.keys(row).forEach(item => {
                if (item.includes('status')) {
                  row[item] = status
                }
              })
            },
            // 取消标记为本学期教学目标
            unmarkTarget(row) {
                row['isTarget'] = false;
                row['targetStatus'] = 0;
                this.markNow(row, false);
                this.updateTarget([row['id']], false)
            },
            // 选择批量设置分数
            selectBatchEditScore(index) {
                this.batchEditScoreIndex = index
            },
            // 显示更多
            showEvaluationMoreRow() {
                this.isMoreRowLoading = true
                this.getEvaluationTableData( ++this.evaluationTableCurrentPage)
            },
            // 显示更多列
            showEvaluationMoreColumn() {
                this.evaluationColumnDisplayNum += this.EvaluationColumnDisplayStep
                this.adjustEvaluationTableHeight(true)
            },
            // 批量设置分数
            setBatchScore(row, column) {
                // 当前目标的评分范围
                const scoreList = row.options && row.options.map(s => +s.value) || []

                if (this.isBatchEdit && this.batchEditScoreIndex < 0) {
                    this.$notify({
                        title: '提示',
                        message: '请选择分数',
                        type: 'warning'
                    })
                    return
                }

                if (this.isBatchEdit && !scoreList.includes(this.batchEditScoreIndex)) {
                    this.$notify({
                        title: '提示',
                        message: '此分数不在该目标评分范围内',
                        type: 'warning'
                    })
                    return
                }

                if (this.isBatchEdit && this.batchEditScoreIndex > -1) {
                    row[column['property']] = this.batchEditScoreIndex
                    this.setTargetScore(row, column, this.batchEditScoreIndex)
                }
            },
            // 单个设置分数
            setSingleScore(score) {
                if (score !== '') {
                    score = +score
                }

                this.scorePopoverRow[this.scorePopoverColumn['property']] = score
                this.setTargetScore(this.scorePopoverRow, this.scorePopoverColumn, score)
                this.closeScorePopover()
            },
            // 设置目标分数
            setTargetScore(row, column, score) {
                if (!row || !column) return

                const selectedTermObj = this.termList.find(s => s.name === this.selectedTermName)
                let termId = ''
                let schoolYear = ''
                let type = ''
                let studentId = ''

                if (selectedTermObj) {
                    schoolYear = selectedTermObj.schoolYear
                    termId = selectedTermObj.termId
                }

                if (column['property'].includes('_')) {
                    [type, studentId] = column['property'].split('_')
                }

                if (!type || !studentId) return

                let params = {
                    subjectId: this.subjectId,
                    targetId: row['id'],
                    studentId,
                    schoolYear,
                    termId,
                }

                switch(type) {
                    case 'before':
                        params['targetScore'] = score
                        break
                    case 'after':
                        params['afterClassScore'] = score
                        break
                    case 'end':
                        params['teacherScore'] = score
                        break
                    case 'finish':
                        params['finishScore'] = score
                        break
                }

                this.$https.post('/api/tk/qbotTeach/score/add', params).then(response => {
                    if (response['code'] !== 0) return
                }).catch(error => {
                    this.$notify.error({
                        title: '错误',
                        message: error.message || error.data.message,
                    })
                })
            },
            filterAddTargetScore(index) {
                this.addTargetDialogScoreIndex = index
            },
            // 显示移动端作业情况页面
            showWorkInfo(targetId, studentId, row) {
                this.evaluateId = row.id
                this.evaluateName = row.name
                this.evaluateOptions = row.options
                this.sendStudentId = studentId
                this.workInfoStudentName = this.studentList.find(s => s['id'] === studentId).name || ''
                this.getWorkInfo(targetId, studentId)
                this.isWorkInfoPanelShown = true
            },
            closeWorkInfo() {
                this.isWorkInfoPanelShown = false
            },
            // 打开批量添加教学目标窗口
            showTargetListDialog(id) {
                this.isAddTargetDialogVisible = true
                this.getBatchTargetList(id)
            },
            // 关闭批量添加教学目标窗口
            closeTargetListDialog() {
                this.isAddTargetDialogVisible = false
                this.batchTargetList = []
                this.addTargetDialogScoreIndex = 0
            },
            removeBatchTargetItem(index) {
                this.batchTargetList.splice(index, 1)
            },
            // 批量添加教学目标
            addBatchTarget() {
                this.updateTarget(this.batchTargetListComputed.map(s => s.id))
                this.closeTargetListDialog()
            },
            // 更新教学目标
            updateTarget(targetIds = [], teachTarget = true) {
                if (!this.subjectId
                    || !targetIds
                    || targetIds.length === 0
                    || !this.batchTargetListComputed.length === 0
                    || (this.selectedGroupIds.length === 0 && this.selectedStudentIds.length === 0)
                    || !this.selectedSchoolYear
                    || !this.selectedTermId) return

                this.$https.post('/api/tk/qbotTeach/teachTarget/update', {
                    targetIds: targetIds,
                    groupIds: this.selectedGroupIds,
                    studentIds: this.selectedStudentIds,
                    subjectId: this.subjectId,
                    schoolYear: this.selectedSchoolYear,
                    termId: this.selectedTermId,
                    teachTarget: teachTarget
                }).then(response => {
                    if (response['code'] !== 0) return
                }).catch(error => {
                    this.$notify.error({
                        title: '错误',
                        message: error.message || error.data.message,
                    })
                })
            },
            // 获取批量教学目标
            getBatchTargetList(id) {
                if (!this.subjectId
                    || (this.selectedGroupIds.length === 0 && this.selectedStudentIds.length === 0)
                    || !this.selectedSchoolYear
                    || !this.selectedTermId) return

                return this.$https.post('/api/tk/qbotTeach/teachTarget/batchAdd', {
                    itemId: id, // this.activeNode.id,
                    groupIds: this.selectedGroupIds,
                    studentIds: this.selectedStudentIds,
                    subjectId: this.subjectId,
                    schoolYear: this.selectedSchoolYear,
                    termId: this.selectedTermId
                }).then(response => {
                    if (response['code'] !== 0) return
                    this.batchTargetList = response['data']
                }).catch(error => {
                    this.$notify.error({
                        title: '错误',
                        message: error.message || error.data.message,
                    })
                })
            },
            // 获取作业完成情况
            getWorkInfo(targetId, studentId) {
                this.currentTargetId = targetId
                this.currentStudentId = studentId
                this.$https.get('/api/conn/clock/punches/my/target', {
                    params: {
                        targetId: targetId,
                        studentId: studentId
                    }
                }).then(response => {
                    if (response['code'] !== 0 || !response['data']) return
                    this.workInfoList = response['data']['punchedResults'] || []
                }).catch(error => {
                    this.$notify.error({
                        title: '错误',
                        message: error.message || error.data.message,
                    })
                })
            },
            // 下载目标分析表
            downloadAnalysisTable() {
                if (!this.subjectId
                    || (this.selectedGroupIds.length === 0 && this.selectedStudentIds.length === 0)
                    || !this.selectedSchoolYear
                    || !this.selectedTermId) return

                this.$https.post('/api/tk/qbotTeach/teachTarget/downloadTargetAnalysis', {
                    itemId: this.activeNode.id,
                    groupIds: this.selectedGroupIds,
                    studentIds: this.selectedStudentIds,
                    subjectId: this.subjectId,
                    schoolYear: this.selectedSchoolYear,
                    termId: this.selectedTermId
                }, {
                    responseType: 'blob'
                }).then(response => {
                    if (response['type'] === 'application/json') return

                    const url = window.URL.createObjectURL(response)
                    let element = document.createElement('a')
                    element.setAttribute('href', url)
                    element.setAttribute('download', '目标分析' + +new Date() + '.xlsx')
                    element.click()
                    element = null
                }).catch(error => {
                    this.$notify.error({
                        title: '错误',
                        message: error.message || error.data.message,
                    })
                })
            },
            // 下载教学目标
            downloadTarget() {
                if (!this.subjectId
                    || (this.selectedGroupIds.length === 0 && this.selectedStudentIds.length === 0)
                    || !this.selectedSchoolYear
                    || !this.selectedTermId) return

                this.$https.post('/api/tk/qbotTeach/teachTarget/downloadTeachTarget', {
                    itemId: this.activeNode.id,
                    groupIds: this.selectedGroupIds,
                    studentIds: this.selectedStudentIds,
                    subjectId: this.subjectId,
                    schoolYear: this.selectedSchoolYear,
                    termId: this.selectedTermId
                }, {
                    responseType: 'blob'
                }).then(response => {
                    if (response['type'] === 'application/json') return

                    const url = window.URL.createObjectURL(response)
                    let element = document.createElement('a')
                    element.setAttribute('href', url)
                    element.setAttribute('download', '教学目标' + +new Date() + '.docx')
                    element.click()
                    element = null
                }).catch(error => {
                    this.$notify.error({
                        title: '错误',
                        message: error.message || error.data.message,
                    })
                })
            },
            showScorePopover(row, column, event) {
                this.isScorePopoverVisible = true
                const popoverElement = document.querySelector('.score-popover')

                if (popoverElement) {
                    popoverElement.style.left = event.clientX - 50 + 'px'

                    if (event.clientY + 180 > document.documentElement.clientHeight) {
                        popoverElement.style.top = event.clientY - 180 + 'px'
                    } else {
                        popoverElement.style.top = event.clientY + 30 + 'px'
                    }
                }
                this.scorePopoverRow = row
                this.scorePopoverColumn = column
                // 判断是否为学生的教学目标

                let type = ''
                let studentId = ''
                if (column['property'].includes('_')) {
                    [type, studentId] = column['property'].split('_')
                }
                this.checked = row['status_' + studentId]
            },
            closeScorePopover() {
                this.isScorePopoverVisible = false
            },
            clearContent() {
                // this.tabIndex = 0
                this.searchText = ''
                this.activeNode = {}
                this.nodeNameChain = []
                this.nodeNameChainBackup = []
                this.searchedKnowledgeList = []
                this.selectedSearchItemIndex = -1
                this.allFilterStudentListIndex = 0
                this.chartTypeIndex = 0
                this.isLessNumSetterShown = false
                this.isGreaterNumSetterShown = false
                this.isMyTeachingGoalChecked = false
                this.isNoEvaluatedGoalChecked = false
                this.chartOriginalData = []
                this.analysisTableData = []
                this.analysisColumnList = []
                this.analysisRowTotal = 0
                this.analysisCurrentPage = 1
                this.currentSort = {
                    columnId: '',
                    order: ''
                }
                this.columnSortOrders = ['ascending', 'descending', null]
                this.evaluationColumnList = []
                this.evaluationTableData = []
                this.evaluationTableCurrentPage = 1
                this.isBatchEdit = false
                this.batchEditScoreIndex = -1
                this.isMoreBtnShown = false
                this.isMinorAdjust = false
                this.isAddTargetDialogVisible = false
                this.addTargetDialogScoreIndex = 0
                this.batchTargetList = []
                this.isWorkInfoPanelShown = false
                this.workInfoList = []
                this.workInfoStudentName = ''
                this.isScorePopoverVisible = false
                this.scorePopoverRow = {}
                this.scorePopoverColumn = {}

                if (this.analysisChart) {
                    this.analysisChart.dispose()
                }
            },
            getWorkInfoImageSrcList(fileList, index) {
                let srcList = fileList.filter(s => s['fileType'] === 2).map(s => convertToHttps(s['publicAddress']))
                srcList = srcList.slice(index).concat(srcList.slice(0, index))
                return srcList
            },
            openWorkInfoVideoAudio(url) {
                this.showVideoPlayer = true
                this.workInfoVideoAudioUrl = convertToHttps(url)
            },
            showStudentGrowth(studentId, studentName) {
                this.studentGrowthVisible = true
                this.studentGrowthStudentId = studentId
                this.studentGrowthStudentName = studentName
                this.studentGrowthUrl = `${location.protocol}//${location.host}${location.pathname}#/studentGrowth?studentId=${studentId}&studentName=${studentName}`
            },
            onStudentGrowLoaded() {
                this.isStudentGrowthLoading = false
            },
            closeStudentGrowth(event) {
                if (event.data === 'close') {
                    this.studentGrowthVisible = false
                }
            },
            // 切换学生个人状态
            changeSingleStatus (row, column) {
                if (!row || !column) return

                const selectedTermObj = this.termList.find(s => s.name === this.selectedTermName)
                let termId = ''
                let schoolYear = ''
                let type = ''
                let studentId = ''

                if (selectedTermObj) {
                    schoolYear = selectedTermObj.schoolYear
                    termId = selectedTermObj.termId
                }

                if (column['property'].includes('_')) {
                    [type, studentId] = column['property'].split('_')
                }


                if (!type || !studentId) return;

                this.$https.post('/api/tk/qbotTeach/teachTarget/update', {
                    targetIds: [row['id']],
                    groupIds: [],
                    studentIds: [studentId],
                    subjectId: this.subjectId,
                    schoolYear: schoolYear,
                    termId: termId,
                    teachTarget: this.checked
                }).then(response => {
                    if (response.code === 0) {
                        row['status_' + studentId] = this.checked
                        let rightCount = 0;
                        let sum = 0
                        Object.keys(row).forEach(item => {
                            if (item.includes('status')) {
                                if (row[item]) {
                                    rightCount ++
                                }
                                sum ++
                            }
                        })
                        if (rightCount === sum) {
                            row.isTarget = true;
                            row.targetStatus = 2
                        } else if (rightCount < sum && rightCount !== 0) {
                            row.isTarget = true;
                            row.targetStatus = 1
                        } else if (rightCount < sum && rightCount === 0) {
                            row.isTarget = false;
                            row.targetStatus = 0
                        }
                    }
                }).catch(error => {
                    this.$notify.error({
                        title: '错误',
                        message: error.message || error.data.message,
                    })
                })
            },
            getPointFileList (id, name) {// 抽屉获取文件列表（原）
                if(!id) return;
                this.$https.get(`/api/tk/qbotTeach/manage/selectPkgItemFiles`, {
                    params: {
                      pkgItemId: id
                    }
                }).then(res => {
                    if (res.code === 0) {
                        this.drawFileList = res.data;
                        this.pointName = name;
                        this.showDrawer = true
                    }
                }).catch(error => {
                    this.$errorLog(error)
                })
            },
            getPointFileList2(row) {// 抽屉获取文件列表（新）
              if (!row.id) return
              this.pointName = row.name
              this.pointId = row.id
              this.drawerCurrentPage = 1
              this.$https.post('/api/tk/qbotTeach/manage/page/pkgItemDetailWithCategory', {
                  subjectId: this.subjectId,
                  pkgItemId: this.pointId,
                  pageSize: 20,
                  pageNum: this.drawerCurrentPage,
                  showAllSub: !this.checkedDrawer
              }).then(res => {
                  if (res.code === 0) {
                    this.drawFileList = []
                    this.drawFileList = res.data.data
                    this.totalFileCounts = res.data.total
                    this.showDrawer = true
                  }
              }).catch(error => {
                  this.$errorLog(error)
              })
            },
            // 抽屉切换是否只查看本级文件
            handleCheckedChange() {
                this.drawerCurrentPage = 1
                this.$https.post('/api/tk/qbotTeach/manage/page/pkgItemDetailWithCategory', {
                    subjectId: this.subjectId,
                    pkgItemId: this.pointId,
                    pageSize: 20,
                    pageNum: this.drawerCurrentPage,
                    showAllSub: !this.checkedDrawer
                }).then(res => {
                    if (res.code === 0) {
                        this.drawFileList = res.data.data
                        this.totalFileCounts = res.data.total
                    }
                }).catch(error => {
                    this.$errorLog(error)
                })
            },
            // 抽屉分页切换
            handleCurrentChange() {
                this.$https.post('/api/tk/qbotTeach/manage/page/pkgItemDetailWithCategory', {
                    subjectId: this.subjectId,
                    pkgItemId: this.pointId,
                    pageSize: 20,
                    pageNum: this.drawerCurrentPage,
                    showAllSub: !this.checkedDrawer
                }).then(res => {
                    if (res.code === 0) {
                        this.drawFileList = res.data.data
                        this.totalFileCounts = res.data.total
                    }
                }).catch(error => {
                    this.$errorLog(error)
                })
            },
            judgeFilePlay (info) {
                if (info.type === 4) {
                  this.$https.get(info.transcodeImg).then(res => {
                    if (res.status === 200) {
                      this.workInfoVideoAudioUrl = info.url;
                      this.showVideoPlayer = true
                    } else {
                      this.$notify({
                        title: '提示',
                        message: '转码中, 请稍等',
                        type: 'warning'
                      });
                    }
                  }).catch(() => {
                    this.$notify({
                      title: '提示',
                      message: '转码中, 请稍等',
                      type: 'warning'
                    });
                  })
                } else if (info.type === 7) {
                  this.workInfoVideoAudioUrl = info.url;
                  this.showVideoPlayer = true
                } else if (info.type === 6) {
                  return
                } else {
                  // 其他文件为下载
                  window.location.href = info.url
                }
             },
            // 添加教师评价
            addTeacherEvaluate () {
                if(!this.sendEvaluateId) return
                this.$https.get(`/api/conn/clock/punches/target/add`, {
                    params: {
                        studentId: this.sendStudentId,
                        targetId: this.evaluateId,
                        optionItemId: this.sendEvaluateId
                    }
                }).then(res => {
                    if (res.code === 0) {
                        this.sendEvaluateId = ''
                        this.showAddEvaluate = false
                        // 重新获取列表
                        this.getWorkInfo(this.currentTargetId, this.currentStudentId)
                    }
                }).catch(error => {
                    console.log(error)
                })
            },
            showIframe () {
                this.taskPath = `${location.protocol}//${location.host}/check-in/#/newTask`
                // this.taskPath = `http://192.168.5.172:8080/#/newTask`
                this.showStartTask = true
                this.iframeTest()
            },
            // iframe发送数据
            iframeTest () {
                setTimeout(() => {
                    let mapFrame = this.$refs['mapFrame']
                    // 处理数据格式
                    let data = {status: 200}
                    data.subject = {name: this.$store.state.subjectActive.name, id: this.subjectId}
                    data.taskName = this.evaluateName
                    if (mapFrame.attachEvent){  //兼容浏览器判断
                        mapFrame.attachEvent("onload", function(){
                            let iframeWin = mapFrame.contentWindow
                            iframeWin.postMessage(data,'*')
                        })
                    } else {
                        mapFrame.onload = function(){
                            let iframeWin = mapFrame.contentWindow
                            iframeWin.postMessage(data,'*')
                        }
                        let iframeWin = mapFrame.contentWindow
                        iframeWin.postMessage(data,'*')
                    }
                }, 1000)
            }
        },
        filters: {
            // 返回今天 昨天 前天或正常时间
            formatDate: function (value) {
                if (!value) return ''
                let date
                if (typeof value === 'string') {
                    date = new Date(value.toString().replace(/-/g, '/'))
                } else {
                    date = new Date(value)
                }
                let mon = date.getMonth() + 1
                mon = mon < 10 ? '0' + mon : mon
                let d = date.getDate()
                d = d < 10 ? '0' + d : d
                let h = date.getHours()
                h = h < 10 ? '0' + h : h
                let m = date.getMinutes()
                m = m < 10 ? '0' + m : m
                let now = +new Date()
                const oneDayMillisecond = 1000 * 3600 * 24
                let offset = now % oneDayMillisecond - date.getTimezoneOffset() * 60 * 1000
                let dayDivision = [now - offset - 2 * oneDayMillisecond, now - offset - oneDayMillisecond, now - offset]
                if (date < dayDivision[0]) {
                    return `${mon}月${d}日 ${h}:${m}`
                } else if (date >= dayDivision[0] && date < dayDivision[1]) {
                    return `前天 ${h}:${m}`
                } else if (date >= dayDivision[1] && date < dayDivision[2]) {
                    return `昨天 ${h}:${m}`
                } else {
                    return `今天 ${h}:${m}`
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .individual-teaching2 {
        overflow-y: hidden;
        position: relative;
        height: 100%;
        padding-top: 60px;
        box-sizing: border-box;
        font-family: Alibaba-PuHuiTi-Regular;
        background-color: #F5F6F7;

        .container {
            position: relative;
            width: 1440px;
            height: calc(100% - 20px);
            margin: 0 auto;

            .tabs {
                text-align: left;
                border-bottom: 1px solid #E6E6E6;
                .tab {
                    display: inline-block;
                    margin-right: 28px;
                    padding: 6px 4px;
                    color: #666666;
                    font-size: 18px;
                    cursor: pointer;
                }
                .selected {
                    color: #2196F3;
                    border-bottom: 2px solid #2196F3;
                }
            }

            .left-part {
                overflow: auto;
                vertical-align: top;
                display: inline-block;
                width: 200px;
                height: calc(100% - 74px);
                margin-top: 10px;
                padding: 16px 10px;
                background-color: #ffffff;

                .search-box {
                    .el-input {
                        vertical-align: middle;
                        width: 138px;
                        text-align: left;

                        /deep/ .el-input__inner {
                            height: 32px;
                            padding: 0 8px;
                            border: none;
                            background-color: #F4F4F4;
                        }
                    }

                    .el-icon-search {
                        font-size: 16px;
                    }

                    & > span {
                        position: relative;
                        display: inline-block;
                        vertical-align: middle;
                        width: 35px;
                        height: 32px;
                        margin-left: -2px;
                        line-height: 32px;
                        border-top-right-radius: 4px;
                        border-bottom-right-radius: 4px;
                        color: #ffffff;
                        background-color: #2F9DF4;
                        cursor: pointer;
                    }
                }

                .publisher-grade-filter {
                    margin-top: 10px;
                    color: #2F9DF4;

                    .el-popover__reference {
                        cursor: pointer;
                    }
                }

                .knowledge-tree {
                    margin-top: 10px;

                    .search-items {
                        text-align: left;

                        & > div {
                            padding: 5px 2px;
                            border-bottom: 1px solid #F4F4F4;
                            cursor: pointer;

                            &:hover {
                                color: #2196F3;
                            }
                        }

                        .active {
                            color: #2196F3;
                            background-color: #E6F4FF;
                        }
                    }
                }
            }

            .right-part {
                overflow: auto;
                position: relative;
                vertical-align: top;
                display: inline-block;
                width: calc(100% - 240px);
                height: calc(100% - 40px);
                margin-top: 10px;
                margin-left: 14px;
                border-radius: 4px;
                background-color: #ffffff;
                &::-webkit-scrollbar {
                    width: 6px;
                    height: 6px;
                    background-color: transparent;
                }
                &::-webkit-scrollbar-thumb {
                    border-radius: 10px;
                    background-color: #8cc7f6;
                }
                .selection-bar {
                    padding: 20px;
                    text-align: left;
                    border-radius: 4px;
                    background-color: #ffffff;
                    & > .el-select {
                        margin-right: 12px;
                        /deep/ .el-input__inner {
                            height: 36px !important;
                            font: {
                                family: Alibaba-PuHuiTi-Regular;
                                size: 14px;
                            }
                        }

                        /deep/ .el-tag {
                            border-radius: 20px;
                        }

                        /deep/ .el-tag.el-tag--info {
                            color: #2196F3;
                            background-color: #E6F4FF;
                            border-color: transparent;
                        }

                        /deep/ .el-icon-close:before {
                            content: "\E6DB";
                            color: #2196F3;
                            background-color: #A9D9FF;
                            border-radius: 20px;
                        }
                    }
                    .term-selection {
                        width: 197px;
                    }
                    .group-selection {
                        width: 262px;
                    }
                    & > .evaluation-filter {
                        display: inline-block;
                        border: 1px solid #E0E0E0;
                        border-radius: 4px;
                        color: #999999;
                        & > div {
                            display: inline-block;
                            padding: 8px 16px;
                            cursor: pointer;
                            &:not(:first-of-type) {
                                border-left: 1px solid #E0E0E0;
                            }
                            &:first-of-type {
                                border: {
                                    top-left-radius: 4px;
                                    bottom-left-radius: 4px;
                                }
                            }
                            &:last-of-type {
                                border: {
                                    top-right-radius: 4px;
                                    bottom-right-radius: 4px;
                                }
                            }
                        }
                        .selected {
                            font: {
                                family: Alibaba-PuHuiTi-Medium;
                            }
                            color: #2196F3;
                            background-color: #F7F7F7;
                        }
                    }
                }
                .container {
                    /*overflow: auto;*/
                    box-sizing: border-box;
                    width: 100%;
                    /*height: calc(100% - 90px);*/
                    /*margin-top: 12px;*/
                    padding: 0 24px;
                    background-color: #ffffff;
                    font-family: Alibaba-PuHuiTi-Medium;
                    &::-webkit-scrollbar {
                        width: 6px;
                        height: 6px;
                        background-color: transparent;
                    }
                    &::-webkit-scrollbar-thumb {
                        border-radius: 10px;
                        background-color: #2F9DF4;
                    }
                    .header {
                        display: flex;
                        justify-content: space-between;
                        .breadcrumb {
                            & > span {
                                font: {
                                    size: 16px;
                                }
                                color: #999999;
                            }
                            & > span:last-of-type {
                                color: #1E8DFF;
                            }
                            .node-name {
                                cursor: pointer;
                            }
                        }
                        .el-dropdown-link {
                            font: {
                                size: 14px;
                            }
                            color: #2196F3;
                            cursor: pointer;
                        }
                        .operation {
                            & > div {
                                display: inline-block;
                                margin-left: 12px;
                                cursor: pointer;
                                & > i, & > img, & > span {
                                    vertical-align: middle;
                                }
                                & > span {
                                    font-size: 14px;
                                }
                                & > img {
                                    margin-right: 3px;
                                }
                            }
                            .filter-label {
                                padding: 3px 10px;
                                border-radius: 50px;
                                color: #666666;
                                background-color: #EDEDED;
                                .el-icon-circle-check {
                                    color: #CCCCCC;
                                }
                            }
                            .checked {
                                color: #ffffff;
                                background-color: #2196F3;
                            }
                            .el-icon-circle-check {
                                font-size: 17px;
                            }
                            .download, .edit {
                                color: #2196F3;
                            }
                        }
                    }
                    .chart-container {
                        .top {
                            margin-top: 10px;
                            & > div {
                                display: inline-block;
                            }
                        }
                        .switcher {
                            color: #999999;
                            border: 1px solid #E0E0E0;
                            border-radius: 3px;
                            & > span {
                                display: inline-block;
                                padding: 6px 12px;
                                cursor: pointer;
                                &:first-of-type {
                                    border: {
                                        top-left-radius: 3px;
                                        bottom-right-radius: 3px;
                                    }
                                    border-right: 1px solid #E0E0E0;
                                }
                                &:last-of-type {
                                    border: {
                                        top-right-radius: 3px;
                                        bottom-right-radius: 3px;
                                    }
                                }
                            }
                            .selected {
                                color: #333333;
                                background-color: #F7F7F7;
                            }
                        }
                        .legend {
                            margin-left: 39px;
                            font-size: 12px;
                            i {
                                display: inline-block;
                                vertical-align: middle;
                                width: 12px;
                                height: 0;
                                margin-right: 6px;
                            }
                            span {
                                vertical-align: middle;
                                margin-right: 10px;
                                color: #999999;
                            }
                            .before {
                                border: 1px solid #F69D3F;
                            }
                            .after {
                                border: 1px solid #50B5FF;
                            }
                            .end {
                                border: 1px solid #8E84FC;
                            }
                        }
                        .no-evaluation {
                            padding-left: 20px;
                            /deep/ .el-checkbox__label {
                                color: #999999;
                            }
                        }
                        .chart-wrapper {
                            overflow: hidden;
                            width: 100%;
                            height: 280px
                        }
                        .chart {
                            width: calc(100% + 500px);
                            height: 430px;
                        }
                    }
                    .table-container {
                        position: relative;
                        margin-top: 20px;
                        padding-bottom: 20px;
                        .description {
                            display: flex;
                            margin-bottom: 20px;
                            text-align: left;
                            justify-content: space-between;
                            color: #666666;
                            font-size: 12px;
                            & > div {
                                & > span, & > img {
                                    vertical-align: middle;
                                }
                            }
                            .download {
                                color: #2196F3;
                                font-size: 14px;
                                cursor: pointer;
                                & > img {
                                    margin-right: 3px;
                                }
                            }
                            .el-icon-warning {
                                vertical-align: middle;
                                color: #FF9C2F;
                            }
                            .scope {
                                display: inline-block;
                                min-width: 36px;
                                height: 20px;
                                text-align: center;
                                border-bottom: 1px solid #E0E0E0;
                                color: #117DEC;
                                font-size: 14px;
                                cursor: pointer;
                            }
                            .scope-setter {
                                display: inline-block;
                                margin: 0 5px;
                                padding: 4px 6px;
                                border-radius: 4px;
                                background-color: #E8E8E8;
                                .el-dropdown-link {
                                    display: inline-block;
                                    vertical-align: middle;
                                    padding: 6px 12px;
                                    border-radius: 3px;
                                    font-size: 14px;
                                    color: #333333;
                                    background-color: #ffffff;
                                    cursor: pointer;
                                    i {
                                        color: #CCCCCC;
                                    }
                                }
                                .score {
                                    vertical-align: middle;
                                    width: 56px;
                                    margin-left: 6px;
                                    /deep/ .el-input__inner {
                                        height: 34px;
                                        padding: 0 12px;
                                    }
                                }
                                .btn {
                                    display: inline-block;
                                    vertical-align: middle;
                                    height: 32px;
                                    line-height: 32px;
                                    margin-left: 6px;
                                    padding: 0 12px;
                                    border-radius: 4px;
                                    font: {
                                        family: Alibaba-PuHuiTi-Medium;
                                        size: 14px;
                                    }
                                    color: #ffffff;
                                    background-color: #2196F3;
                                    cursor: pointer;
                                }
                            }
                            .scope-color {
                                display: inline-block;
                                width: 16px;
                                height: 16px;
                                margin: 0 2px;
                                border: 1px solid #E8E8E8;
                            }
                            .color-control{
                                display: flex;
                                align-items: center;
                                .left-color{
                                    display: flex;
                                    align-items: center;
                                    .normal{
                                        width: 16px;
                                        height: 16px;
                                    }
                                    .normal-else{
                                        width: 16px;
                                        height: 16px;
                                        opacity: 0.2;
                                    }
                                    .one{
                                        background: #C192F6;
                                    }
                                    .two{
                                        background: #87A8F2;
                                    }
                                    .three{
                                        background: #B8DEA5;
                                    }
                                    .four{
                                        background: #46DCBA;
                                    }
                                    .five{
                                        background: #FFE78F;
                                    }
                                    .six{
                                        background: #FA6690;
                                    }
                                    .seven{
                                        background: #FA9DC2;
                                    }
                                    .eight{
                                        background: #F8625B;
                                    }
                                }
                                .color-choose{
                                    margin: 0 10px;
                                }
                            }
                        }
                        .pager {
                            margin-top: 15px;
                            text-align: right;
                        }
                        /deep/ .blue {
                            background-color: #E0F6FF;
                        }
                        /deep/ .pink {
                            background-color: #FFEDDA;
                        }
                        /deep/ .white {
                            background-color: #ffffff;
                        }
                        /deep/ .one {
                            background-color: #C192F6;
                        }
                        /deep/ .two {
                            background-color: #87A8F2;
                        }
                        /deep/ .three {
                            background-color: #B8DEA5;
                        }
                        /deep/ .four {
                            background-color: #46DCBA;
                        }
                        /deep/ .five {
                            background-color: #FFE78F;
                        }
                        /deep/ .six {
                            background-color: #FA6690;
                        }
                        /deep/ .seven {
                            background-color: #FA9DC2;
                        }
                        /deep/ .eight {
                            background-color: #F8625B;
                        }
                        /deep/ .one-light {
                            background-color: #F3E9FD;
                        }
                        /deep/ .two-light {
                            background-color: #E7EEFC;
                        }
                        /deep/ .three-light {
                            background-color: #F1F8ED;
                        }
                        /deep/ .four-light {
                            background-color: #DAF8F1;
                        }
                        /deep/ .five-light {
                            background-color: #FFFAE9;
                        }
                        /deep/ .six-light {
                            background-color: #FEE0E9;
                        }
                        /deep/ .seven-light {
                            background-color: #FEEBF3;
                        }
                        /deep/ .eight-light {
                            background-color: #FEE0DE;
                        }
                        /deep/ .header-cell {
                            position: relative;
                            padding: 0;
                            text-align: center;
                            background-color: #F7F7F7;
                            border-color: #E8E8E8;
                            color: #333333;
                            font: {
                                family: Alibaba-PuHuiTi-Medium;
                                size: 14px;
                            }
                            & > .cell {
                                position: static;
                                padding: 0 12px
                            }
                            .icon-plus {
                                position: absolute;
                                display: flex;
                                top: 0;
                                right: 0;
                                width: 18px;
                                height: 18px;
                                line-height: 18px;
                                align-items: center;
                                justify-content: center;
                                border-radius: 0 0 0 50%;
                                background-color: #E8E8E8;
                                cursor: pointer;
                                .el-icon-plus {
                                    font: {
                                        size: 14px;
                                        weight: bold;
                                    }
                                    color: #333333;
                                }
                                &:hover {
                                    background-color: #2F9DF4;
                                    .el-icon-plus {
                                        color: #FFFFFF;
                                    }
                                }
                            }
                        }
                        /deep/ .el-table__fixed::before {
                            display: none;
                        }
                        /deep/ .el-table__body-wrapper, /deep/ .el-table__fixed-body-wrapper {
                            &::-webkit-scrollbar {
                                width: 6px;
                                height: 6px;
                                background-color: transparent;
                            }
                            &::-webkit-scrollbar-thumb {
                                border-radius: 10px;
                                background-color: #2F9DF4;
                            }
                        }
                        /deep/ .el-table td, /deep/ .el-table th {
                            padding: 8px 0;
                        }
                        /deep/ .is-sortable.header-cell {
                            padding: 4px 0;
                        }
                        .evaluation-table {
                            .target-update {
                                cursor: pointer;
                                width: 16px;
                            }
                            /deep/ .column-hidden {
                                display: none;
                            }
                            /deep/ .evaluation-header-cell {
                                text-align: center;
                                background-color: #ffffff;
                                font: {
                                    family: Alibaba-PuHuiTi-Medium;
                                    size: 14px;
                                }
                            }
                            /deep/ .evaluation-cell {
                                text-align: center;
                                .editable-batch-score {
                                    cursor: pointer;
                                }
                                .score-changed {
                                    background-color: #FFEDDA;
                                }
                                .small-line-chart {
                                    width: 100%;
                                }
                                .small-line-chart > div {
                                    width: 100% !important;
                                    cursor: pointer !important;
                                }
                            }
                            /deep/ .target-path-row {
                                background-color: #F7F7F7;
                            }
                            /deep/ .evaluation-fixed-column {
                                color: #666666;
                                .target-path {
                                    line-height: 16px;
                                    color: #000000;
                                    background-color: #F7F7F7;
                                    font-size: 10px;
                                }
                            }
                            /deep/ .is-group.has-gutter > tr:first-of-type{
                                color: #000000;
                            }
                            .el-table--border, .el-table--group {
                                border: none;
                            }
                            .el-table--border::after {
                                width: 0;
                            }
                            /deep/ .el-table__header-wrapper tr {
                                & > th:nth-last-child(2), & > td:nth-last-child(2) {
                                    border-right: none;
                                }
                            }
                            /deep/ .el-table__body > tbody > tr {
                                & > td:first-of-type {
                                    text-align: left;
                                    .cell {
                                        justify-content: flex-start;
                                        & > * {
                                            justify-content: flex-start;
                                        }
                                    }
                                }
                                & > td:last-of-type{
                                    border-right: none;
                                }
                                & > td:not([colspan='1']) {
                                    height: 32px;
                                    padding: 0;
                                    border-right: none;
                                    font-size: 14px;
                                    color: #000000;
                                    background-color: #F7F7F7;

                                    .cell > span {
                                        visibility: visible;
                                        vertical-align: middle;
                                    }
                                }
                            }
                            .custom-label {
                                display: inline-block;
                                height: 18px;
                                padding: 0 5px;
                                line-height: 18px;
                                border-radius: 9px;
                                color: #ffffff;
                                background-color: #F69D3F;
                                font: {
                                    family: Alibaba-PuHuiTi-Medium;
                                    size: 11px;
                                }
                                &+* {
                                    vertical-align: middle;
                                }
                            }
                            .custom-target-name {
                                width: calc(100% - 110px);
                                margin-left: 10px;
                                margin-right: 10px;
                                border-width: 0;
                                color: #666666;
                                font: {
                                    family: Alibaba-PuHuiTi-Medium;
                                    size: 14px;
                                }
                            }
                            .save-btn {
                                font-size: 12px;
                                color: #2F9DF4;
                                cursor: pointer;
                            }
                            .add-custom-target {
                                font-size: 12px;
                                color: #2196F3;
                                background-color: #F7F7F7;
                                cursor: pointer;
                                & > img, & > span {
                                    vertical-align: middle;
                                }
                            }
                            /deep/ tbody td[colspan='1'] {
                                height: 42px;
                                padding: 0;
                                & > .cell {
                                    display: flex;
                                    height: 100%;
                                    padding: 0;
                                    line-height: 16px;
                                    align-items: center;
                                    justify-content: center;
                                    & > span {
                                        display: flex;
                                        width: 100%;
                                        height: 100%;
                                        align-items: center;
                                        justify-content: center;
                                        & > div {
                                            width: 100%;
                                            height: 100%;
                                            cursor: pointer;
                                        }
                                    }
                                }
                            }
                        }

                        /deep/ .btn-prev, /deep/ .btn-next {
                            color: #CCCCCC;
                        }
                        /deep/ .el-pager {
                            .number {
                                color: #606266;
                                font-size: 14px;
                            }
                            .active {
                                color: #2196F3;
                            }
                        }
                    }
                }
                .more-row {
                    display: flex;
                    margin-top: 18px;
                    color: #2196F3;
                    justify-content: center;
                    background-color: #FFFFFF;
                    & > div {
                        display: flex;
                        width: 100px;
                        height: 24px;
                        align-items: center;
                        justify-content: center;
                        border: 1px solid #2196F3;
                        border-radius: 12px;
                        cursor: pointer;
                    }
                }
                .more-column {
                    position: absolute;
                    right: -22px;
                    top: 28px;
                    width: 20px;
                    height: 20px;
                    z-index: 15;
                    color: #2196F3;
                    border-radius: 50%;
                    border: 1px solid #2196F3;
                    cursor: pointer;
                }
            }
        }
        .footer {
            position: fixed;
            left: 0;
            bottom: 0;
            width: 100%;
            height: 56px;
            background-color: #E8E8E8;
            z-index: 100;
            & > div {
                display: flex;
                box-sizing: border-box;
                width: 1440px;
                height: 100%;
                padding: 0 100px;
                margin: 0 auto;
                justify-content: space-between;
                align-items: center;
            }
            .score {
                display: inline-block;
                width: 54px;
                height: 32px;
                margin-right: 10px;
                line-height: 32px;
                background-color: #ffffff;
                border-radius: 16px;
                box-shadow: 0 5px 10px 0 rgba(155,155,155,0.27);
                color: #333333;
                font: {
                    family: Alibaba-PuHuiTi-Medium;
                    size: 14px;
                }
                cursor: pointer;
            }
            .selected {
                color: #ffffff;
                background-color: #2196F3;
                box-shadow: 0 7px 10px 0 rgba(33,150,243,0.51);
            }
            .exit-batch-edit {
                color: #333333;
                font-size: 14px;
                cursor: pointer;
                & > * {
                    vertical-align: middle;
                }
                & > img {
                    margin-right: 3px;
                }
            }
        }
        /deep/ .add-target-dialog {
            .el-dialog__header {
                padding: 0;
            }
            .el-dialog__close {
                display: none;
            }
            .el-dialog__body {
                padding: 24px 30px;
                .title {
                    text-align: left;
                    color: #36363A;
                    font: {
                        family: Alibaba-PuHuiTi-Medium;
                        weight: bold;
                        size: 20px;
                    }
                }
                .confirm-tip {
                    color: #000000;
                    & > span {
                        color: #F69D3F;
                    }
                    font: {
                        family: Alibaba-PuHuiTi-Medium;
                        size: 18px;
                    }
                }
                .table-header {
                    display: flex;
                    margin-top: 24px;
                    align-items: center;
                    justify-content: space-between;
                    & > div:first-of-type {
                        color: #333333;
                        font: {
                            size: 18px;
                        }
                    }
                    & > div:last-of-type {
                        display: flex;
                        align-items: center;
                        .score {
                            display: flex;
                            width: 176px;
                            height: 32px;
                            margin-left: 8px;
                            align-items: center;
                            justify-content: center;
                            border: 1px solid #E0E0E0;
                            border-radius: 3px;
                            & > span {
                                flex: 1;
                                height: 32px;
                                line-height: 32px;
                                color: #999999;
                                font: {
                                    family: Alibaba-PuHuiTi-Medium;
                                    size: 14px;
                                }
                                cursor: pointer;
                                &:not(:last-of-type) {
                                    border-right: 1px solid #E0E0E0;
                                }
                                &:first-of-type {
                                    border: {
                                        top-left-radius: 3px;
                                        bottom-left-radius: 3px;
                                    }
                                }
                                &:last-of-type {
                                    border: {
                                        top-right-radius: 3px;
                                        bottom-right-radius: 3px;
                                    }
                                }
                            }
                            .selected {
                                color: #2196F3;
                                background-color: #F7F7F7;
                            }
                        }
                    }
                    .avg-score {
                        margin: 0 5px;
                        color: #2196F3;
                    }
                }
                .table-body {
                    overflow: auto;
                    max-height: 500px;
                    margin-top: 8px;
                    & > div {
                        border-bottom: 1px solid #E8E8E8;
                        &:first-of-type {
                            border-top: 1px solid #E8E8E8;
                        }
                    }
                    .table-row {
                        display: flex;
                        min-height: 50px;
                        align-items: center;
                        & > div {
                            flex: 1;
                            &:first-of-type {
                                text-align: left;
                                color: #333333;
                                font: {
                                    family: Alibaba-PuHuiTi-Medium;
                                    size: 16px;
                                };
                            }
                            &:nth-of-type(2) {
                                color: #666666;
                                font-size: 12px;
                            }
                            &:last-of-type {
                                text-align: right;
                                & > img {
                                    cursor: pointer;
                                }
                            }
                        }
                    }
                    .tip {
                        font-size: 12px;
                        color: #2F9DF4;
                    }
                }
                .buttons {
                    display: flex;
                    margin-top: 18px;
                    justify-content: flex-end;
                    @mixin btn {
                        box-sizing: border-box;
                        width: 96px;
                        height: 36px;
                        line-height: 36px;
                        border-radius: 4px;
                        cursor: pointer;
                    }
                    .cancel-btn {
                        @include btn;
                        border: 1px solid #2196F3;
                        color: #2196F3;
                    }
                    .confirm-btn {
                        @include btn;
                        margin-left: 8px;
                        color: #FFFFFF;
                        background-color: #2196F3;
                    }
                }
            }
        }
        .work-info-panel {
            position: fixed;
            right: 0;
            top: 0;
            overflow: auto;
            box-sizing: border-box;
            width: 383px;
            height: 100vh;
            padding: 0 20px;
            background-color: #F7F7F7;
            box-shadow: 0 0 16px 0 rgba(0,0,0,0.16);
            z-index: 100;
            & > .top {
                display: flex;
                padding: 20px 0;
                align-items: center;
                justify-content: space-between;
                color: #000000;
                font: {
                    family: Alibaba-PuHuiTi-Medium;
                    size: 18px;
                }
                & > .el-icon-close {
                    font-size: 20px;
                    cursor: pointer;
                }
            }
            .func-button{
                height: 37px;
                display: flex;
                align-items: center;
                justify-content: space-between;
                margin-bottom: 24px;
                .normal-button{
                    width: 156px;
                    height: 37px;
                    line-height: 37px;
                    background: #FFFFFF;
                    border-radius: 4px;
                    border: 1px solid #2196F3;
                    font-size: 14px;
                    font-family: PingFangSC-Medium, PingFang SC;
                    font-weight: 500;
                    color: #2196F3;
                    cursor: pointer;
                }
                .task{
                    color: white;
                    background: #2196F3;
                }
            }
            .add-evaluate{
                min-height: 170px;
                background: #FFFFFF;
                box-shadow: 0 2px 10px 0 rgba(222,222,222,0.5);
                border-radius: 16px;
                margin-bottom: 20px;
                padding: 16px;
                box-sizing: border-box;
                .user-info{
                    display: flex;
                    align-items: center;
                    .user-icon{
                        width: 28px;
                        height: 28px;
                        line-height: 28px;
                        border-radius: 50%;
                        background: #2196F3;
                        color: white;
                        margin-right: 8px;
                    }
                    .user-name{
                        font-size: 20px;
                        color: #2196F3;
                    }
                }
                .option-part{
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    min-height: 50px;
                    border-top: 1px solid #E8E8E8;
                    border-bottom: 1px solid #E8E8E8;
                    margin-top: 10px;
                    .left-word{
                        width: 160px;
                    }
                    .right-part{
                        /deep/ .el-input{
                            .el-input__inner{
                                width: 120px;
                                border: none;
                                text-align: right;
                            }
                        }
                    }
                }
                .button-part{
                    margin-top: 15px;
                    display: flex;
                    align-items: center;
                    justify-content: flex-end;
                    .inner-button{
                        font-size: 14px;
                        color: #2196F3;
                        cursor: pointer;
                        margin-left: 16px;
                    }
                }
            }
            .work-item {
                margin-bottom: 20px;
                padding: 16px;
                border-radius: 16px;
                background-color: #FFFFFF;
                & > .header {
                    display: flex;
                    padding-bottom: 11px;
                    align-items: center;
                    justify-content: space-between;
                    border-bottom: 1px solid #E8E8E8;
                    & > div {
                        &:first-of-type {
                            font: {
                                family: Alibaba-PuHuiTi-Medium;
                                size: 20px;
                            }
                            color: #2196F3;
                            & > * {
                                vertical-align: middle;
                            }
                        }
                    }
                    .avatar {
                        width: 28px;
                        height: 28px;
                        margin-right: 8px;
                    }
                    .starts {
                        & > img {
                            margin-left: 10px;
                        }
                    }
                }
                & > .performance {
                    padding: 9px 0;
                    text-align: left;
                    border-bottom: 1px dashed #E8E8E8;
                    & > .title {
                        font: {
                            size: 16px;
                        }
                        color: #000000;
                        & > * {
                            vertical-align: middle;
                        }
                        .point {
                            display: inline-block;
                            width: 6px;
                            height: 6px;
                            margin-right: 9px;
                            border-radius: 50%;
                            background-color: #2196F3;
                        }
                    }
                    .images {
                        font-size: 0;
                    }
                    .photo {
                        width: 64px;
                        height: 64px;
                        margin: 6px 6px 0 0;
                        border-radius: 14px;
                        cursor: pointer;
                    }
                    .video {
                        position: relative;
                        display: inline-block;
                        margin: 10px 6px 0 0;
                        cursor: pointer;
                        .photo {
                            margin: 0;
                        }
                        .el-icon-caret-right {
                            position: absolute;
                            font-size: 50px;
                            color: #ffffff;
                            left: 50%;
                            top: 50%;
                            transform: translateX(-50%) translateY(-50%);
                        }
                    }
                }
                & > .target {
                    display: flex;
                    padding: 11px 0;
                    justify-content: space-between;
                    color: #000000;
                    border-bottom: 1px solid #E8E8E8;
                }
                & > .time-comment {
                    display: flex;
                    justify-content: space-between;
                    padding: 15px 0 11px 0;
                    font-size: 14px;
                    & > div:first-of-type {
                        color: #999999;
                    }
                    & > div:last-of-type {
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        color: #2196F3;
                        & > div {
                            display: flex;
                            align-items: center;
                            &:first-of-type {
                                padding-right: 6px;
                                border-right: 1px solid #E0E0E0;
                            }
                            &:last-of-type {
                                padding-left: 6px;
                            }
                            & > img {
                                margin-right: 3px;
                            }
                        }
                    }
                }
                & > .comments {
                    padding: 0 11px;
                    border-radius: 8px;
                    background-color: #F7F7F7;
                    font-size: 14px;
                    & > .thumbs {
                        padding: 11px 0;
                        text-align: left;
                        color: #0074D0;
                        & > .thumb {
                            display: inline-block;
                            margin-right: 10px;
                            & > * {
                                vertical-align: middle;
                            }
                            & > img {
                                margin-right: 3px;
                            }
                        }
                    }
                    & > .comment {
                        padding: 7px 0;
                        text-align: left;
                        & > span:first-of-type {
                            color: #0074D0;
                        }
                        & > span:last-of-type {
                            color: #333333;
                        }
                    }
                    & > div:not(:first-of-type) {
                        border-top: 1px solid #E8E8E8;
                    }
                }
            }
        }
        .start-task{
            position: fixed;
            right: 0;
            top: 0;
            overflow: auto;
            box-sizing: border-box;
            width: 500px;
            height: 100vh;
            padding: 0 20px;
            background-color: #F7F7F7;
            box-shadow: 0 0 16px 0 rgba(0,0,0,0.16);
            z-index: 101;
            .header{
                height: 50px;
                display: flex;
                align-items: center;
                justify-content: flex-end;
                .close{
                    font-size: 20px;
                    cursor: pointer;
                }
            }
            .inner-frame{
                width: 100%;
                height: calc(100% - 60px);
            }
        }
        .student-growth {
            position: fixed;
            top: 0;
            right: 0;
            z-index: 10;
            & > iframe {
                border-color: transparent;
            }
            @media screen and (max-width: 1100px) {
                & > iframe {
                    width: 100vw;
                    height: 100vh;
                }
            }
            @media screen and (min-width: 1100px) {
                & > iframe {
                    width: 50vw;
                    height: 100vh;
                }
            }
        }
        .student-growth-enter-active {
            transition: all 1s;
        }
        .student-growth-enter {
            transform: translateX(100%);
        }
        .cell{
            position: relative;
            .inner-img{
                position: absolute;
                width: 8px;
                right: 0;
                top: 0;
            }
        }
        /deep/.for-draw{
            .el-drawer{
                width: 383px!important;
                overflow: auto;
                .content{
                    padding: 0 20px;
                    height: 100%;
                    .header{
                        min-height: 60px;
                        border-bottom: rgba(0,0,0,0.16) solid 1px;
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        .left{
                            font-size: 18px;
                            font-family: PingFangSC-Semibold, PingFang SC;
                            font-weight: 600;
                            color: #000000;
                        }
                        .right{
                            font-size: 22px;
                            .inner{
                                cursor: pointer;
                            }
                        }
                    }
                    .draw-checked {
                        margin-left: 230px;
                    }
                    .file-type {
                        .type-name {
                            border-bottom: rgba(0,0,0,0.16) solid 1px;
                            padding: 11px 0px 11px 8px;
                            display: flex;
                            align-items: center;
                            font-size: 16px;
                            font-weight: bold;
                            position: relative;
                            div {
                                display: inline-block;
                                transform: translateY(-50%);
                                position: absolute;
                                left: 0;
                                top: 50%;
                                height: 10px;
                                width: 4px;
                                border-radius: 2px;
                                background-color: #2196f3;
                            }
                        }
                        .file-list{
                            height: calc(100% - 120px);
                            overflow: auto;
                            .file-item{
                                border-bottom: rgba(0,0,0,0.16) solid 1px;
                                display: flex;
                                align-items: center;
                                padding: 11px 0;
                                .inner-img{
                                    width: 19px;
                                    cursor: pointer;
                                    margin-right: 4px;
                                }
                                .name{
                                    font-size: 14px;
                                    font-family: PingFangSC-Regular, PingFang SC;
                                    font-weight: 400;
                                    color: #333333;
                                }
                            }
                        }
                    }
                }
                .el-drawer__header{
                    display: none;
                }
            }
        }
    }
</style>
<style lang="scss">
    .popover-publisher-grade {
        font-family: Alibaba-PuHuiTi-Regular;

        & > div {
            & > p {
                margin-block-end: 10px;
                font-size: 16px;
                color: #2F9DF4;

                &:first-of-type {
                    margin-block-start: 0;
                }

                &:not(:first-of-type) {
                    margin-block-start: 10px;
                }

            }

            & > div > span {
                display: inline-block;
                margin-right: 10px;
                padding: 3px 5px;
                font-size: 13px;
                border-radius: 4px;
                color: #999999;
                cursor: pointer;
            }

            .active {
                color: #ffffff;
                background-color: #2F9DF4;
            }
        }
    }

/******************** el-tree样式 **************************/
    .el-tree-node__content {
        .el-tree-node__expand-icon {
            color: #2196F3;
            font-size: 14px;
        }
        & > .is-leaf {
            color: transparent;
        }
        & > .expanded {
            transform: rotate(0);
            &::before {
               content: "\e7a2"
            }
        }
    }
    .el-tree-node__children {
        position: relative;
        & > .el-tree-node {
            position: relative;
            &::before {
                position: absolute;
                top: 0;
                left: 12px;
                width: 1px;
                height: 100%;
                content: "";
                border-left: 1px solid #D0EAEF;
                z-index: 10;
            }
            & > .el-tree-node__content {
                & > .el-tree-node__label {
                    position: relative;
                    display: inline-block;
                    &::after {
                        position: absolute;
                        top: 10px;
                        left: -32px;
                        width: 12px;
                        height: 0;
                        content: "";
                        border-bottom: 1px solid #D0EAEF;
                    }
                }
            }
        }
        & > div:last-of-type {
            &::before {
                height: 13px;
            }
        }
    }
    .el-tree > .el-tree-node > .el-tree-node__children {
        & > .el-tree-node {
            &::before {
                left: 12px;
            }
            & > .el-tree-node__children > .el-tree-node {
                &::before {
                    left: 30px;
                }
                & > .el-tree-node__children > .el-tree-node {
                    &::before {
                        left: 48px;
                    }
                    & > .el-tree-node__children > .el-tree-node {
                        &::before {
                            left: 66px;
                        }
                        & > .el-tree-node__children > .el-tree-node {
                            &::before {
                                left: 84px;
                            }
                            & > .el-tree-node__children > .el-tree-node {
                                &::before {
                                    left: 102px;
                                }
                                & > .el-tree-node__children > .el-tree-node {
                                    &::before {
                                        left: 120px;
                                    }
                                    & > .el-tree-node__children > .el-tree-node {
                                        &::before {
                                            left: 138px;
                                        }
                                        & > .el-tree-node__children > .el-tree-node {
                                            &::before {
                                                left: 156px;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
/******************** el-tree样式 **************************/

    .score-popover-cell {
        cursor: pointer;
        position: relative;
        .inner-img{
            position: absolute;
            right: 0;
            top: 0;
            width: 8px;
        }
    }

    .score-popover {
        left: 0;
        top: 0;
        padding: 5px 0;
        cursor: pointer;
        .score-item {
            min-height: 28px;
            padding: 0 16px;
            line-height: 28px;
            cursor: pointer;
            &:hover {
                color: #2196F3;
                background-color: rgba(206,226,242,0.2);
                font-size: 14px;
            }
        }
        .my-goal{
            padding: 6px 16px;
            border-top: solid 1px #E9E9E9;
            font-size: 14px;
        }
    }

    .student-selector.el-dropdown-menu {
        overflow: auto;
        max-height: 300px;
        &::-webkit-scrollbar {
            width: 6px;
            background-color: transparent;
        }
        &::-webkit-scrollbar-thumb {
            border-radius: 6px;
            background-color: #2F9DF4;
        }
    }

    .gutter {
        display: none;
    }
</style>
